// import React, { useState, useEffect, useRef } from "react";
// import {
//   Form,
//   Button,
//   Container,
//   Row,
//   Col,
//   Card,
//   Modal,
//   Dropdown,
// } from "react-bootstrap";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import { useNavigate } from "react-router-dom";

// const API_URL = process.env.REACT_APP_API_URL;

// function CreateProject() {
//   const navigate = useNavigate();
//   const [name, setName] = useState("");
//   const [projectSize, setProjectSize] = useState("");
//   const [status, setStatus] = useState("active");
//   const [projectStatus, setProjectStatus] = useState("ongoing");
//   const [images, setImages] = useState([]);
//   const [image1, setImage1] = useState(null);
//   const [imageprojectmap, setimageprojectmap] = useState(null);
//   const [reraRegistrationNo, setReraRegistrationNo] = useState("");
//   const [location, setLocation] = useState("");
//   const [description, setDescription] = useState("");
//   const [youtubeLink, setYoutubeLink] = useState("");
//   const [legality, setLegality] = useState("");
//   const [businessVolume, setBusinessVolume] = useState("");
//   const [city, setCity] = useState("");
//   const [state, setState] = useState("");
//   const [landmark, setLandmark] = useState("");
//   const [propertyChainPapers, setPropertyChainPapers] = useState([]);
//   const [availableAmenities, setAvailableAmenities] = useState([]);
//   const [statesList, setStatesList] = useState([]);
//   const [citiesList, setCitiesList] = useState([]);
//   const [selectedStateId, setSelectedStateId] = useState("");
//   const [keyTransports, setKeyTransports] = useState([]);
//   const [amenities, setAmenities] = useState([]);
//   const [newTransportName, setNewTransportName] = useState("");
//   const [newTransportDistance, setNewTransportDistance] = useState("");
//   const [errors, setErrors] = useState({});
//   const [isLoading, setIsLoading] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [modalMessage, setModalMessage] = useState("");
//   const [modalType, setModalType] = useState("success");
//   const imageInputRef = useRef(null);
//   const imageInputRef1 = useRef(null);
//   const imageInputRef2 = useRef(null);
//   const propertyChainPaperRef = useRef(null);
//   const [locationMap, setLocationMap] = useState("");

//   const showCustomModal = (message, type) => {
//     setModalMessage(message);
//     setModalType(type);
//     setShowModal(true);
//   };

//   const closeCustomModal = () => {
//     setShowModal(false);
//     setModalMessage("");
//     setModalType("success");
//   };

//   const getAuthToken = () => {
//     return localStorage.getItem("token");
//   };

//   useEffect(() => {
//     const fetchAmenities = async () => {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomModal(
//           "Authentication token not found. Please log in.",
//           "error"
//         );
//         return;
//       }
//       try {
//         const amenitiesResponse = await fetch(`${API_URL}/amenities-list`, {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         const amenitiesData = await amenitiesResponse.json();

//         if (amenitiesResponse.ok && amenitiesData.status === "1") {
//           setAvailableAmenities(amenitiesData.data);
//         } else {
//           console.error("Failed to fetch amenities:", amenitiesData.message);
//         }
//       } catch (error) {
//         console.error("Error fetching amenities:", error);
//       }
//     };
//     fetchAmenities();
//   }, []);

//   useEffect(() => {
//     const fetchStates = async () => {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomModal(
//           "Authentication token not found. Please log in.",
//           "error"
//         );
//         return;
//       }
//       try {
//         const statesResponse = await fetch(`${API_URL}/state-list`, {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         const statesData = await statesResponse.json();

//         if (statesData.status == "1") {
//           setStatesList(statesData.data);
//         } else {
//           console.error("Failed to fetch states:", statesData.message);
//         }
//       } catch (error) {
//         console.error("Error fetching states:", error);
//       }
//     };
//     fetchStates();
//   }, []);

//   useEffect(() => {
//     const fetchCities = async () => {
//       if (selectedStateId) {
//         const token = getAuthToken();
//         if (!token) {
//           showCustomModal(
//             "Authentication token not found. Please log in.",
//             "error"
//           );
//           return;
//         }

//         try {
//           const citiesResponse = await fetch(`${API_URL}/city-list`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ state_id: selectedStateId }),
//           });
//           const citiesData = await citiesResponse.json();
//           if (citiesResponse.ok && citiesData.status === "1") {
//             setCitiesList(citiesData.data);
//           } else {
//             setCitiesList([]);
//             console.error("Failed to fetch cities:", citiesData.message);
//           }
//         } catch (error) {
//           setCitiesList([]);
//           console.error("Error fetching cities:", error);
//         }
//       } else {
//         setCitiesList([]);
//       }
//     };

//     fetchCities();
//   }, [selectedStateId]);

//   const validateForm = () => {
//     const newErrors = {};
//     if (!name.trim()) newErrors.name = "Project name is required.";
//     if (!projectSize || isNaN(projectSize) || parseFloat(projectSize) <= 0) {
//       newErrors.projectSize = "Project size must be a positive number.";
//     }

//     if (!reraRegistrationNo.trim())
//       newErrors.reraRegistrationNo = "RERA Registration No. is required.";
//     if (!location.trim()) newErrors.location = "Location is required.";
//     if (!description.trim()) newErrors.description = "Description is required.";
//     if (!legality.trim())
//       newErrors.legality = "Approved Authority details are required.";
//     if (!projectStatus.trim())
//       newErrors.projectStatus = "Project Status is required.";

//     if (!city) newErrors.city = "City is required.";
//     if (!state) newErrors.state = "State is required.";
//     if (!landmark.trim()) newErrors.landmark = "Landmark is required.";
//     if (amenities.length === 0)
//       newErrors.amenities = "At least one amenity must be selected.";
//     if (keyTransports.length === 0)
//       newErrors.keyTransports = "At least one Key Transport entry is required.";
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleImageChange = (e) => {
//     const files = Array.from(e.target.files);
//     if (images.length + files.length > 20) {
//       showCustomModal(
//         "You can only upload a maximum of 20 project images.",
//         "error"
//       );
//       if (imageInputRef.current) imageInputRef.current.value = "";
//       return;
//     }

//     setErrors((prevErrors) => ({ ...prevErrors, images: "" }));
//     setImages([...images, ...files]);
//     e.target.value = null;
//   };

//   const removeImage = (indexToRemove) => {
//     setImages((prevImages) =>
//       prevImages.filter((_, index) => index !== indexToRemove)
//     );
//     if (images.length === 1 && indexToRemove === 0) {
//       if (imageInputRef.current) imageInputRef.current.value = "";
//     }
//   };

//   const handleImageChange1 = (e) => {
//     const file = e.target.files[0];
//     if (file && !file.type.startsWith("image/")) {
//       showCustomModal("Please upload an image file for the thumbnail.", "error");
//       if (imageInputRef1.current) imageInputRef1.current.value = "";
//       return;
//     }
//     setImage1(file);
//     if (errors.image1) {
//       setErrors((prev) => ({ ...prev, image1: null }));
//     }
//   };

//   const removeImage1 = () => {
//     setImage1(null);
//     if (imageInputRef1.current) {
//       imageInputRef1.current.value = "";
//     }
//   };

//   const handleImageChange2 = (e) => {
//     const file = e.target.files[0];
//     if (file && file.type !== "application/pdf") {
//       showCustomModal("Please upload a PDF file for the project map.", "error");
//       if (imageInputRef2.current) imageInputRef2.current.value = "";
//       return;
//     }
//     setimageprojectmap(file);
//     if (errors.imageprojectmap) {
//       setErrors((prev) => ({ ...prev, imageprojectmap: null }));
//     }
//   };

//   const removeImage2 = () => {
//     setimageprojectmap(null);
//     if (imageInputRef2.current) {
//       imageInputRef2.current.value = "";
//     }
//   };

//   const handlePropertyChainPaperChange = (e) => {
//     const files = Array.from(e.target.files);
//     const newPdfs = files.filter((file) => file.type === "application/pdf");

//     if (newPdfs.length !== files.length) {
//       showCustomModal(
//         "Only PDF files are allowed for Property Chain Papers.",
//         "error"
//       );
//       if (propertyChainPaperRef.current)
//         propertyChainPaperRef.current.value = "";
//       return;
//     }

//     setPropertyChainPapers([...propertyChainPapers, ...newPdfs]);
//     setErrors((prevErrors) => ({ ...prevErrors, propertyChainPapers: "" }));
//     e.target.value = null;
//   };

//   const removePropertyChainPaper = (indexToRemove) => {
//     setPropertyChainPapers((prevPdfs) =>
//       prevPdfs.filter((_, index) => index !== indexToRemove)
//     );
//     if (propertyChainPapers.length === 1 && indexToRemove === 0) {
//       if (propertyChainPaperRef.current)
//         propertyChainPaperRef.current.value = "";
//     }
//   };

//   const handleAmenityToggle = (amenityId) => {
//     const updatedAmenities = amenities.includes(amenityId)
//       ? amenities.filter((id) => id !== amenityId)
//       : [...amenities, amenityId];
//     setAmenities(updatedAmenities);
//     if (errors.amenities)
//       setErrors((prev) => ({ ...prev, amenities: null }));
//   };

//   const addKeyTransport = () => {
//     if (newTransportName.trim() && newTransportDistance.trim()) {
//       setKeyTransports((prev) => [
//         ...prev,
//         {
//           name: newTransportName.trim(),
//           distance: newTransportDistance.trim(),
//         },
//       ]);
//       setNewTransportName("");
//       setNewTransportDistance("");
//       if (errors.keyTransports)
//         setErrors((prev) => ({ ...prev, keyTransports: null }));
//     } else {
//       showCustomModal(
//         "Please enter both a name and a distance for Key Transport.",
//         "error"
//       );
//     }
//   };

//   const removeKeyTransport = (indexToRemove) => {
//     setKeyTransports((prev) =>
//       prev.filter((_, index) => index !== indexToRemove)
//     );
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setErrors({});

//     if (!validateForm()) {
//       return;
//     }

//     setIsLoading(true);
//     const formData = new FormData();
//     formData.append("name", name);
//     formData.append("project_rera_no", reraRegistrationNo);
//     formData.append("location", location);
//     formData.append("bussiness_volume", businessVolume);
//     formData.append("description", description);
//     formData.append("youtube_links", youtubeLink);
//     formData.append("approve_authority", legality);
//     formData.append("state", state);
//     formData.append("city", city);
//     formData.append("land_mark", landmark);
//     const amenitiesArrayOfObjects = amenities.map((id) => ({ id: String(id) }));
//     formData.append("aminities", JSON.stringify(amenitiesArrayOfObjects));
//     formData.append("total_township_area", projectSize);
//     formData.append("key_transport", JSON.stringify(keyTransports));
//     formData.append("status", status);
//     formData.append("location_map", locationMap);

//     if (image1) {
//       formData.append("thumbnail", image1);
//     }

//     if (imageprojectmap) {
//       formData.append("map_pdf", imageprojectmap);
//     }

//     formData.append("project_status", projectStatus);

//     propertyChainPapers.forEach((file) => {
//       formData.append("property_chain_papers[]", file);
//     });

//     images.forEach((imageFile) => {
//       formData.append("image[]", imageFile);
//     });

//     const authToken = localStorage.getItem("token");

//     if (!authToken) {
//       showCustomModal(
//         "Authentication token not found. Please log in.",
//         "error"
//       );
//       setIsLoading(false);
//       return;
//     }

//     try {
//       const response = await fetch(`${API_URL}/project-create`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${authToken}`,
//         },
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error("Server error response:", errorText);
//         throw new Error(`Server responded with status ${response.status}`);
//       }

//       const result = await response.json();
//       if (result.success == "1" || result.status == "1") {
//         showCustomModal(
//           result.message || "Project has been created successfully!",
//           "success"
//         );
//         setName("");
//         setProjectSize("");
//         setStatus("active");
//         setProjectStatus("ongoing");
//         setImages([]);
//         setImage1(null);
//         setimageprojectmap(null);
//         setReraRegistrationNo("");
//         setLocation("");
//         setDescription("");
//         setLegality("");
//         setYoutubeLink("");
//         setBusinessVolume("");
//         setCity("");
//         setState("");
//         setLandmark("");
//         setAmenities([]);
//         setPropertyChainPapers([]);
//         setSelectedStateId("");
//         setKeyTransports([]);
//         setNewTransportName("");
//         setNewTransportDistance("");
//         setLocationMap("");

//         if (imageInputRef.current) imageInputRef.current.value = "";
//         if (imageInputRef1.current) imageInputRef1.current.value = "";
//         if (imageInputRef2.current) imageInputRef2.current.value = "";
//         if (propertyChainPaperRef.current)
//           propertyChainPaperRef.current.value = "";

//         setTimeout(() => {
//           navigate("/all-project");
//         }, 3000);
//       } else {
//         const errorMessage = result.message || "Failed to create project.";
//         showCustomModal(`Error: ${errorMessage}`, "error");
//       }
//     } catch (error) {
//       console.error("Error creating project:", error);
//       showCustomModal(
//         `An unexpected error occurred: ${error.message || ""}`,
//         "error"
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               🏗️
//             </div>
//             <div>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 Create New Project
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 Fill in the details below to add a new project to your system
//               </p>
//             </div>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "30px" }}>
//               <Form onSubmit={handleSubmit}>
//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="name">
//                       <Form.Label>
//                         Project Name <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="text"
//                         value={name}
//                         onChange={(e) => {
//                           setName(e.target.value);
//                           if (errors.name)
//                             setErrors((prev) => ({ ...prev, name: null }));
//                         }}
//                         placeholder="e.g., Grand Residency"
//                         isInvalid={!!errors.name}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.name}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="project_size">
//                       <Form.Label>
//                         Total Townships (Sq. Yard){" "}
//                         <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="number"
//                         value={projectSize}
//                         onChange={(e) => {
//                           setProjectSize(e.target.value);
//                           if (errors.projectSize)
//                             setErrors((prev) => ({
//                               ...prev,
//                               projectSize: null,
//                             }));
//                         }}
//                         placeholder="e.g., 10000"
//                         step="1"
//                         min="0"
//                         isInvalid={!!errors.projectSize}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.projectSize}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group
//                       className="mb-3"
//                       controlId="rera_registration_no"
//                     >
//                       <Form.Label>
//                         Project RERA Number{" "}
//                         <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="text"
//                         value={reraRegistrationNo}
//                         onChange={(e) => {
//                           setReraRegistrationNo(e.target.value);
//                           if (errors.reraRegistrationNo)
//                             setErrors((prev) => ({
//                               ...prev,
//                               reraRegistrationNo: null,
//                             }));
//                         }}
//                         placeholder="Enter RERA registration number"
//                         isInvalid={!!errors.reraRegistrationNo}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.reraRegistrationNo}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="location">
//                       <Form.Label>
//                         Location <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="text"
//                         value={location}
//                         onChange={(e) => {
//                           setLocation(e.target.value);
//                           if (errors.location)
//                             setErrors((prev) => ({
//                               ...prev,
//                               location: null,
//                             }));
//                         }}
//                         placeholder="Enter project location"
//                         isInvalid={!!errors.location}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.location}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="locationMap">
//                       <Form.Label>
//                         Location Map Link{" "}
//                         <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="url"
//                         value={locationMap}
//                         onChange={(e) => {
//                           setLocationMap(e.target.value);
//                           if (errors.locationMap)
//                             setErrors((prev) => ({
//                               ...prev,
//                               locationMap: null,
//                             }));
//                         }}
//                         placeholder="Enter Google Maps or location link"
//                         isInvalid={!!errors.locationMap}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.locationMap}
//                       </Form.Control.Feedback>
//                       <Form.Text className="text-muted">
//                         Enter the URL for the project location map (e.g., Google
//                         Maps link)
//                       </Form.Text>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="businessVolume">
//                       <Form.Label>Business Volume(%) Optional</Form.Label>
//                       <Form.Control
//                         type="number"
//                         value={businessVolume}
//                         onChange={(e) => {
//                           setBusinessVolume(e.target.value);
//                           if (errors.businessVolume)
//                             setErrors((prev) => ({
//                               ...prev,
//                               businessVolume: null,
//                             }));
//                         }}
//                         placeholder="Enter business volume"
//                         isInvalid={!!errors.businessVolume}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.businessVolume}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="state">
//                       <Form.Label>
//                         State <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Select
//                         value={state}
//                         onChange={(e) => {
//                           setState(e.target.value);
//                           setSelectedStateId(e.target.value);
//                           setCity("");
//                           if (errors.state)
//                             setErrors((prev) => ({ ...prev, state: null }));
//                           if (errors.city)
//                             setErrors((prev) => ({ ...prev, city: null }));
//                         }}
//                         isInvalid={!!errors.state}
//                       >
//                         <option value="">Select State</option>
//                         {statesList.map((s) => (
//                           <option key={s.id} value={s.id}>
//                             {s.name}
//                           </option>
//                         ))}
//                       </Form.Select>
//                       <Form.Control.Feedback type="invalid">
//                         {errors.state}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="city">
//                       <Form.Label>
//                         City <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Select
//                         value={city}
//                         onChange={(e) => {
//                           setCity(e.target.value);
//                           if (errors.city)
//                             setErrors((prev) => ({ ...prev, city: null }));
//                         }}
//                         isInvalid={!!errors.city}
//                         disabled={!selectedStateId || citiesList.length === 0}
//                       >
//                         <option value="">Select City</option>
//                         {citiesList.map((c) => (
//                           <option key={c.id} value={c.id}>
//                             {c.name}
//                           </option>
//                         ))}
//                       </Form.Select>
//                       <Form.Control.Feedback type="invalid">
//                         {errors.city}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="landmark">
//                       <Form.Label>
//                         Landmark <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="text"
//                         value={landmark}
//                         onChange={(e) => {
//                           setLandmark(e.target.value);
//                           if (errors.landmark)
//                             setErrors((prev) => ({
//                               ...prev,
//                               landmark: null,
//                             }));
//                         }}
//                         placeholder="Enter nearest landmark"
//                         isInvalid={!!errors.landmark}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.landmark}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="amenities">
//                       <Form.Label>
//                         Amenities <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Dropdown
//                         className={errors?.amenities ? "is-invalid" : ""}
//                       >
//                         <Dropdown.Toggle
//                           variant="transparent"
//                           id="dropdown-amenities"
//                           className="w-100 text-start border"
//                         >
//                           {amenities.length > 0
//                             ? `${amenities.length} selected`
//                             : "Select Amenities"}
//                         </Dropdown.Toggle>

//                         <Dropdown.Menu
//                           style={{
//                             maxHeight: "200px",
//                             overflowY: "auto",
//                             width: "100%",
//                           }}
//                         >
//                           {availableAmenities.map((amenity) => (
//                             <Form.Check
//                               key={amenity.id}
//                               type="checkbox"
//                               id={`amenity-${amenity.id}`}
//                               label={amenity.name}
//                               checked={amenities.includes(amenity.id)}
//                               onChange={() => handleAmenityToggle(amenity.id)}
//                               className="mx-3 d-flex gap-2 align-items-center"
//                             />
//                           ))}
//                         </Dropdown.Menu>
//                       </Dropdown>
//                       {errors.amenities && (
//                         <div className="invalid-feedback d-block">
//                           {errors.amenities}
//                         </div>
//                       )}
//                       <Form.Text className="text-muted">
//                         Click to select amenities.
//                       </Form.Text>
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group
//                       className="mb-3"
//                       controlId="propertyChainPapers"
//                     >
//                       <Form.Label>Property Chain Papers (PDF)</Form.Label>
//                       <Form.Control
//                         type="file"
//                         accept="application/pdf"
//                         multiple
//                         onChange={handlePropertyChainPaperChange}
//                         isInvalid={!!errors.propertyChainPapers}
//                         ref={propertyChainPaperRef}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.propertyChainPapers}
//                       </Form.Control.Feedback>
//                       {propertyChainPapers.length > 0 && (
//                         <div className="mt-2 d-flex flex-wrap gap-2">
//                           {propertyChainPapers.map((file, index) => (
//                             <div
//                               key={index}
//                               className="position-relative d-flex align-items-center border p-2 rounded"
//                             >
//                               <i className="bi bi-file-earmark-pdf-fill me-2 fs-4 text-danger"></i>
//                               <span
//                                 className="text-truncate"
//                                 style={{ maxWidth: "120px" }}
//                               >
//                                 {file.name}
//                               </span>
//                               <Button
//                                 variant="danger"
//                                 size="sm"
//                                 className="position-absolute top-0 end-0 translate-middle badge rounded-pill bg-danger"
//                                 onClick={() => removePropertyChainPaper(index)}
//                                 style={{ cursor: "pointer" }}
//                               >
//                                 X
//                               </Button>
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                       {propertyChainPapers.length > 0 && (
//                         <div className="mt-2 text-muted">
//                           {propertyChainPapers.length} PDF(s) selected
//                         </div>
//                       )}
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Form.Group className="mb-3" controlId="keyTransports">
//                   <Form.Label>
//                     Key Transport <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Row className="mb-2 gy-2">
//                     <Col md={5}>
//                       <Form.Control
//                         type="text"
//                         placeholder="e.g., Malls"
//                         value={newTransportName}
//                         onChange={(e) => setNewTransportName(e.target.value)}
//                         isInvalid={
//                           !!errors.keyTransports && keyTransports.length === 0
//                         }
//                       />
//                     </Col>
//                     <Col md={5}>
//                       <Form.Control
//                         type="text"
//                         placeholder="e.g., 2KM, 190m"
//                         value={newTransportDistance}
//                         onChange={(e) => setNewTransportDistance(e.target.value)}
//                         isInvalid={
//                           !!errors.keyTransports && keyTransports.length === 0
//                         }
//                       />
//                     </Col>
//                     <Col md={2} className="d-grid">
//                       <Button variant="primary" onClick={addKeyTransport}>
//                         Add
//                       </Button>
//                     </Col>
//                   </Row>
//                   <Form.Control.Feedback type="invalid">
//                     {errors.keyTransports}
//                   </Form.Control.Feedback>

//                   {keyTransports.length > 0 && (
//                     <div className="mt-2 border rounded p-3 bg-light">
//                       <h5>Added Locations:</h5>
//                       <ul className="list-unstyled mb-0">
//                         {keyTransports.map((item, index) => (
//                           <li
//                             key={index}
//                             className="d-flex justify-content-between align-items-center mb-1"
//                           >
//                             <span>
//                               <strong>{item.name}:</strong> {item.distance}
//                             </span>
//                             <Button
//                               variant="outline-danger"
//                               size="sm"
//                               onClick={() => removeKeyTransport(index)}
//                             >
//                               Remove
//                             </Button>
//                           </li>
//                         ))}
//                       </ul>
//                     </div>
//                   )}
//                 </Form.Group>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="status">
//                       <Form.Label>
//                         Status <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Select
//                         value={status}
//                         onChange={(e) => setStatus(e.target.value)}
//                       >
//                         <option value="active">Show</option>
//                         <option value="inactive">Hide</option>
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3" controlId="project_status">
//                       <Form.Label>
//                         Project Status <span className="text-danger">*</span>
//                       </Form.Label>
//                       <Form.Select
//                         value={projectStatus}
//                         onChange={(e) => {
//                           setProjectStatus(e.target.value);
//                           if (errors.projectStatus)
//                             setErrors((prev) => ({
//                               ...prev,
//                               projectStatus: null,
//                             }));
//                         }}
//                         isInvalid={!!errors.projectStatus}
//                       >
//                         <option value="ongoing">Ongoing Project</option>
//                         <option value="complete">Complete Project</option>
//                       </Form.Select>
//                       <Form.Control.Feedback type="invalid">
//                         {errors.projectStatus}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Form.Group className="mb-3" controlId="description">
//                   <Form.Label>
//                     Description <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     rows={3}
//                     value={description}
//                     onChange={(e) => {
//                       setDescription(e.target.value);
//                       if (errors.description)
//                         setErrors((prev) => ({
//                           ...prev,
//                           description: null,
//                         }));
//                     }}
//                     placeholder="Enter Description"
//                     isInvalid={!!errors.description}
//                   />

//                   {errors.description && (
//                     <div
//                       className="text-danger mt-1"
//                       style={{ fontSize: "0.875em" }}
//                     >
//                       {errors.description}
//                     </div>
//                   )}
//                 </Form.Group>

//                 <Form.Group className="mb-3" controlId="legality">
//                   <Form.Label>
//                     Approved Authority <span className="text-danger">*</span>
//                   </Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     rows={3}
//                     value={legality}
//                     onChange={(e) => {
//                       setLegality(e.target.value);
//                       if (errors.legality)
//                         setErrors((prev) => ({ ...prev, legality: null }));
//                     }}
//                     placeholder="Enter legality details"
//                     isInvalid={!!errors.legality}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {errors.legality}
//                   </Form.Control.Feedback>
//                 </Form.Group>

//                 <Form.Group className="mb-3" controlId="images-upload-multiple">
//                   <Form.Label>Project Images (Multiple) </Form.Label>
//                   <Form.Control
//                     type="file"
//                     accept="image/*"
//                     multiple
//                     onChange={handleImageChange}
//                     isInvalid={!!errors.images}
//                     ref={imageInputRef}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {errors.images}
//                   </Form.Control.Feedback>
//                   {images.length > 0 && (
//                     <div className="mt-2 d-flex flex-wrap gap-2">
//                       {images.map((file, index) => (
//                         <div key={index} className="position-relative">
//                           <img
//                             src={URL.createObjectURL(file)}
//                             alt={`Preview ${index}`}
//                             className="img-thumbnail"
//                             style={{
//                               width: "100px",
//                               height: "100px",
//                               objectFit: "cover",
//                             }}
//                           />
//                           <Button
//                             variant="danger"
//                             size="sm"
//                             className="position-absolute top-0 end-0 translate-middle badge rounded-pill bg-danger"
//                             onClick={() => removeImage(index)}
//                             style={{ cursor: "pointer" }}
//                           >
//                             X
//                           </Button>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                   {images.length > 0 && (
//                     <div className="mt-2 text-muted">
//                       {images.length}/3 images selected
//                     </div>
//                   )}
//                 </Form.Group>

//                 <Form.Group className="mb-3" controlId="image-upload-single">
//                   <Form.Label>Thumbnail Image</Form.Label>
//                   <Form.Control
//                     type="file"
//                     accept="image/*"
//                     onChange={handleImageChange1}
//                     isInvalid={!!errors.image1}
//                     ref={imageInputRef1}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {errors.image1}
//                   </Form.Control.Feedback>
//                   {image1 && (
//                     <div className="mt-2 position-relative d-inline-block">
//                       <img
//                         src={URL.createObjectURL(image1)}
//                         alt="Single Image Preview"
//                         className="img-thumbnail"
//                         style={{
//                           width: "100px",
//                           height: "100px",
//                           objectFit: "cover",
//                         }}
//                       />
//                       <Button
//                         variant="danger"
//                         size="sm"
//                         className="position-absolute top-0 end-0 translate-middle badge rounded-pill bg-danger"
//                         onClick={removeImage1}
//                         style={{ cursor: "pointer" }}
//                       >
//                         X
//                       </Button>
//                     </div>
//                   )}
//                 </Form.Group>

//                 <Form.Group className="mb-3" controlId="map-upload-pdf">
//                   <Form.Label>Project Map (PDF) </Form.Label>
//                   <Form.Control
//                     type="file"
//                     accept="application/pdf"
//                     onChange={handleImageChange2}
//                     isInvalid={!!errors.imageprojectmap}
//                     ref={imageInputRef2}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {errors.imageprojectmap}
//                   </Form.Control.Feedback>
//                   {imageprojectmap && (
//                     <div className="mt-2 position-relative d-inline-block p-2 border rounded">
//                       <i className="bi bi-file-earmark-pdf-fill me-2 fs-4 text-danger"></i>
//                       <span
//                         className="text-truncate"
//                         style={{
//                           maxWidth: "150px",
//                           display: "inline-block",
//                           verticalAlign: "middle",
//                         }}
//                       >
//                         {imageprojectmap.name}
//                       </span>
//                       <Button
//                         variant="danger"
//                         size="sm"
//                         className="position-absolute top-0 end-0 translate-middle badge rounded-pill bg-danger"
//                         onClick={removeImage2}
//                         style={{ cursor: "pointer" }}
//                       >
//                         X
//                       </Button>
//                     </div>
//                   )}
//                 </Form.Group>

//                 <Form.Group className="mb-3" controlId="youtubelink">
//                   <Form.Label>Youtube Link </Form.Label>
//                   <Form.Control
//                     type="text"
//                     value={youtubeLink}
//                     onChange={(e) => {
//                       setYoutubeLink(e.target.value);
//                       if (errors.youtubeLink)
//                         setErrors((prev) => ({
//                           ...prev,
//                           youtubeLink: null,
//                         }));
//                     }}
//                     placeholder="Enter Your Youtube Link"
//                     isInvalid={!!errors.youtubeLink}
//                   />
//                   {errors.youtubeLink && (
//                     <div
//                       className="text-danger mt-1"
//                       style={{ fontSize: "0.875em" }}
//                     >
//                       {errors.youtubeLink}
//                     </div>
//                   )}
//                 </Form.Group>

//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "flex-end",
//                     paddingTop: "20px",
//                     borderTop: "1.5px dashed #e2e8f0",
//                   }}
//                 >
//                   <button
//                     type="submit"
//                     disabled={isLoading}
//                     style={{
//                       padding: "13px 42px",
//                       borderRadius: "12px",
//                       border: "none",
//                       background: isLoading
//                         ? "#cbd5e1"
//                         : "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                       color: "#ffffff",
//                       fontSize: "14.5px",
//                       fontWeight: "800",
//                       letterSpacing: "0.5px",
//                       cursor: isLoading ? "not-allowed" : "pointer",
//                       transition: "all 0.3s ease",
//                       boxShadow: isLoading
//                         ? "none"
//                         : "0 8px 24px rgba(30, 87, 153, 0.3)",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       gap: "10px",
//                       minWidth: "220px",
//                     }}
//                   >
//                     {isLoading ? (
//                       <>
//                         <span
//                           style={{
//                             width: "16px",
//                             height: "16px",
//                             border: "2px solid rgba(255,255,255,0.3)",
//                             borderTop: "2px solid #ffffff",
//                             borderRadius: "50%",
//                             display: "inline-block",
//                             animation: "spin 0.8s linear infinite",
//                           }}
//                         />
//                         Loading...
//                       </>
//                     ) : (
//                       "Submit"
//                     )}
//                   </button>
//                 </div>

//                 <div
//                   style={{
//                     marginTop: "20px",
//                     paddingTop: "20px",
//                     borderTop: "1.5px dashed #e2e8f0",
//                     textAlign: "center",
//                   }}
//                 >
//                   <p
//                     style={{
//                       margin: 0,
//                       fontSize: "12.5px",
//                       color: "#94a3b8",
//                       fontWeight: "500",
//                     }}
//                   >
//                     🔒 All fields marked with{" "}
//                     <span style={{ color: "#dc2626" }}>*</span> are required
//                   </p>
//                 </div>
//               </Form>
//             </div>
//           </div>

//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>

//       <Modal show={showModal} onHide={closeCustomModal} centered>
//         <Modal.Header closeButton>
//           <Modal.Title
//             className={modalType === "success" ? "text-success" : "text-danger"}
//           >
//             {modalType === "success" ? "Success!" : "Error!"}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>{modalMessage}</p>
//         </Modal.Body>
//         <Modal.Footer className="justify-content-center">
//           <Button
//             variant={modalType === "success" ? "success" : "danger"}
//             onClick={closeCustomModal}
//           >
//             OK
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       <style>{`
//         @keyframes spin {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }
//       `}</style>
//     </>
//   );
// }

// export default CreateProject;


// import React, { useState, useEffect, useRef } from "react";
// import {
//   Form,
//   Button,
//   Row,
//   Col,
//   Modal,
//   Dropdown,
// } from "react-bootstrap";
// import { useNavigate } from "react-router-dom";
// import {
//   FaBuilding,
//   FaMapMarkerAlt,
//   FaImage,
//   FaFilePdf,
//   FaYoutube,
//   FaCheckCircle,
//   FaTimesCircle,
//   FaTrash,
//   FaPlus,
//   FaInfoCircle,
//   FaSave,
//   FaArrowLeft,
// } from "react-icons/fa";

// const API_URL = process.env.REACT_APP_API_URL;

// // ─── Shared input style ───
// const labelStyle = {
//   display: "block",
//   fontSize: "12.5px",
//   fontWeight: "700",
//   color: "#1e3a5f",
//   marginBottom: "6px",
//   letterSpacing: "0.2px",
// };

// const inputStyle = {
//   width: "100%",
//   padding: "10px 14px",
//   borderRadius: "10px",
//   border: "1.5px solid #e2e8f0",
//   fontSize: "13.5px",
//   fontWeight: "500",
//   color: "#1e3a5f",
//   outline: "none",
//   boxSizing: "border-box",
//   transition: "all 0.2s ease",
//   background: "#ffffff",
// };

// const sectionHeaderStyle = {
//   display: "flex",
//   alignItems: "center",
//   gap: "10px",
//   marginBottom: "18px",
//   marginTop: "8px",
//   paddingBottom: "10px",
//   borderBottom: "2px dashed #e2e8f0",
// };

// const sectionIconStyle = {
//   width: "32px",
//   height: "32px",
//   borderRadius: "9px",
//   background: "linear-gradient(135deg, #e8f1fb, #dbeafe)",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
//   fontSize: "15px",
//   flexShrink: 0,
//   color: "#1e5799",
// };

// const sectionTitleStyle = {
//   margin: 0,
//   fontSize: "13.5px",
//   fontWeight: "800",
//   color: "#1e5799",
//   letterSpacing: "0.3px",
//   textTransform: "uppercase",
// };

// function CreateProject() {
//   const navigate = useNavigate();
//   const [name, setName] = useState("");
//   const [projectSize, setProjectSize] = useState("");
//   const [status, setStatus] = useState("active");
//   const [projectStatus, setProjectStatus] = useState("ongoing");
//   const [images, setImages] = useState([]);
//   const [image1, setImage1] = useState(null);
//   const [imageprojectmap, setimageprojectmap] = useState(null);
//   const [reraRegistrationNo, setReraRegistrationNo] = useState("");
//   const [location, setLocation] = useState("");
//   const [description, setDescription] = useState("");
//   const [youtubeLink, setYoutubeLink] = useState("");
//   const [legality, setLegality] = useState("");
//   const [businessVolume, setBusinessVolume] = useState("");
//   const [city, setCity] = useState("");
//   const [state, setState] = useState("");
//   const [landmark, setLandmark] = useState("");
//   const [propertyChainPapers, setPropertyChainPapers] = useState([]);
//   const [availableAmenities, setAvailableAmenities] = useState([]);
//   const [statesList, setStatesList] = useState([]);
//   const [citiesList, setCitiesList] = useState([]);
//   const [selectedStateId, setSelectedStateId] = useState("");
//   const [keyTransports, setKeyTransports] = useState([]);
//   const [amenities, setAmenities] = useState([]);
//   const [newTransportName, setNewTransportName] = useState("");
//   const [newTransportDistance, setNewTransportDistance] = useState("");
//   const [errors, setErrors] = useState({});
//   const [isLoading, setIsLoading] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [modalMessage, setModalMessage] = useState("");
//   const [modalType, setModalType] = useState("success");
//   const imageInputRef = useRef(null);
//   const imageInputRef1 = useRef(null);
//   const imageInputRef2 = useRef(null);
//   const propertyChainPaperRef = useRef(null);
//   const [locationMap, setLocationMap] = useState("");

//   const showCustomModal = (message, type) => {
//     setModalMessage(message);
//     setModalType(type);
//     setShowModal(true);
//   };

//   const closeCustomModal = () => {
//     setShowModal(false);
//     setModalMessage("");
//     setModalType("success");
//   };

//   const getAuthToken = () => localStorage.getItem("token");

//   // ═══════════════════════════════════════════
//   // 🔹 FETCH AMENITIES
//   // ═══════════════════════════════════════════
//   useEffect(() => {
//     const fetchAmenities = async () => {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomModal(
//           "Authentication token not found. Please log in.",
//           "error"
//         );
//         return;
//       }
//       try {
//         const amenitiesResponse = await fetch(`${API_URL}/amenities-list`, {
//           method: "GET",
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         const amenitiesData = await amenitiesResponse.json();

//         if (amenitiesResponse.ok && amenitiesData.status === "1") {
//           setAvailableAmenities(amenitiesData.data);
//         } else {
//           console.error("Failed to fetch amenities:", amenitiesData.message);
//         }
//       } catch (error) {
//         console.error("Error fetching amenities:", error);
//       }
//     };
//     fetchAmenities();
//   }, []);

//   // ═══════════════════════════════════════════
//   // 🔹 FETCH STATES
//   // ═══════════════════════════════════════════
//   useEffect(() => {
//     const fetchStates = async () => {
//       const token = getAuthToken();
//       if (!token) {
//         showCustomModal(
//           "Authentication token not found. Please log in.",
//           "error"
//         );
//         return;
//       }
//       try {
//         const statesResponse = await fetch(`${API_URL}/state-list`, {
//           method: "GET",
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         const statesData = await statesResponse.json();

//         if (statesData.status == "1") {
//           setStatesList(statesData.data);
//         } else {
//           console.error("Failed to fetch states:", statesData.message);
//         }
//       } catch (error) {
//         console.error("Error fetching states:", error);
//       }
//     };
//     fetchStates();
//   }, []);

//   // ═══════════════════════════════════════════
//   // 🔹 FETCH CITIES BY STATE
//   // ═══════════════════════════════════════════
//   useEffect(() => {
//     const fetchCities = async () => {
//       if (selectedStateId) {
//         const token = getAuthToken();
//         if (!token) {
//           showCustomModal(
//             "Authentication token not found. Please log in.",
//             "error"
//           );
//           return;
//         }

//         try {
//           const citiesResponse = await fetch(`${API_URL}/city-list`, {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify({ state_id: selectedStateId }),
//           });
//           const citiesData = await citiesResponse.json();
//           if (citiesResponse.ok && citiesData.status === "1") {
//             setCitiesList(citiesData.data);
//           } else {
//             setCitiesList([]);
//             console.error("Failed to fetch cities:", citiesData.message);
//           }
//         } catch (error) {
//           setCitiesList([]);
//           console.error("Error fetching cities:", error);
//         }
//       } else {
//         setCitiesList([]);
//       }
//     };

//     fetchCities();
//   }, [selectedStateId]);

//   // ═══════════════════════════════════════════
//   // 🔹 VALIDATION
//   // ═══════════════════════════════════════════
//   const validateForm = () => {
//     const newErrors = {};
//     if (!name.trim()) newErrors.name = "Project name is required.";
//     if (!projectSize || isNaN(projectSize) || parseFloat(projectSize) <= 0) {
//       newErrors.projectSize = "Project size must be a positive number.";
//     }
//     if (!reraRegistrationNo.trim())
//       newErrors.reraRegistrationNo = "RERA Registration No. is required.";
//     if (!location.trim()) newErrors.location = "Location is required.";
//     if (!description.trim()) newErrors.description = "Description is required.";
//     if (!legality.trim())
//       newErrors.legality = "Approved Authority details are required.";
//     if (!projectStatus.trim())
//       newErrors.projectStatus = "Project Status is required.";
//     if (!city) newErrors.city = "City is required.";
//     if (!state) newErrors.state = "State is required.";
//     if (!landmark.trim()) newErrors.landmark = "Landmark is required.";
//     if (amenities.length === 0)
//       newErrors.amenities = "At least one amenity must be selected.";
//     if (keyTransports.length === 0)
//       newErrors.keyTransports = "At least one Key Transport entry is required.";
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 IMAGE HANDLERS
//   // ═══════════════════════════════════════════
//   const handleImageChange = (e) => {
//     const files = Array.from(e.target.files);
//     if (images.length + files.length > 20) {
//       showCustomModal(
//         "You can only upload a maximum of 20 project images.",
//         "error"
//       );
//       if (imageInputRef.current) imageInputRef.current.value = "";
//       return;
//     }

//     setErrors((prevErrors) => ({ ...prevErrors, images: "" }));
//     setImages([...images, ...files]);
//     e.target.value = null;
//   };

//   const removeImage = (indexToRemove) => {
//     setImages((prevImages) =>
//       prevImages.filter((_, index) => index !== indexToRemove)
//     );
//     if (images.length === 1 && indexToRemove === 0) {
//       if (imageInputRef.current) imageInputRef.current.value = "";
//     }
//   };

//   const handleImageChange1 = (e) => {
//     const file = e.target.files[0];
//     if (file && !file.type.startsWith("image/")) {
//       showCustomModal("Please upload an image file for the thumbnail.", "error");
//       if (imageInputRef1.current) imageInputRef1.current.value = "";
//       return;
//     }
//     setImage1(file);
//     if (errors.image1) setErrors((prev) => ({ ...prev, image1: null }));
//   };

//   const removeImage1 = () => {
//     setImage1(null);
//     if (imageInputRef1.current) imageInputRef1.current.value = "";
//   };

//   const handleImageChange2 = (e) => {
//     const file = e.target.files[0];
//     if (file && file.type !== "application/pdf") {
//       showCustomModal("Please upload a PDF file for the project map.", "error");
//       if (imageInputRef2.current) imageInputRef2.current.value = "";
//       return;
//     }
//     setimageprojectmap(file);
//     if (errors.imageprojectmap)
//       setErrors((prev) => ({ ...prev, imageprojectmap: null }));
//   };

//   const removeImage2 = () => {
//     setimageprojectmap(null);
//     if (imageInputRef2.current) imageInputRef2.current.value = "";
//   };

//   const handlePropertyChainPaperChange = (e) => {
//     const files = Array.from(e.target.files);
//     const newPdfs = files.filter((file) => file.type === "application/pdf");

//     if (newPdfs.length !== files.length) {
//       showCustomModal(
//         "Only PDF files are allowed for Property Chain Papers.",
//         "error"
//       );
//       if (propertyChainPaperRef.current)
//         propertyChainPaperRef.current.value = "";
//       return;
//     }

//     setPropertyChainPapers([...propertyChainPapers, ...newPdfs]);
//     setErrors((prevErrors) => ({ ...prevErrors, propertyChainPapers: "" }));
//     e.target.value = null;
//   };

//   const removePropertyChainPaper = (indexToRemove) => {
//     setPropertyChainPapers((prevPdfs) =>
//       prevPdfs.filter((_, index) => index !== indexToRemove)
//     );
//     if (propertyChainPapers.length === 1 && indexToRemove === 0) {
//       if (propertyChainPaperRef.current)
//         propertyChainPaperRef.current.value = "";
//     }
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 AMENITY / TRANSPORT HANDLERS
//   // ═══════════════════════════════════════════
//   const handleAmenityToggle = (amenityId) => {
//     const updatedAmenities = amenities.includes(amenityId)
//       ? amenities.filter((id) => id !== amenityId)
//       : [...amenities, amenityId];
//     setAmenities(updatedAmenities);
//     if (errors.amenities) setErrors((prev) => ({ ...prev, amenities: null }));
//   };

//   const addKeyTransport = () => {
//     if (newTransportName.trim() && newTransportDistance.trim()) {
//       setKeyTransports((prev) => [
//         ...prev,
//         {
//           name: newTransportName.trim(),
//           distance: newTransportDistance.trim(),
//         },
//       ]);
//       setNewTransportName("");
//       setNewTransportDistance("");
//       if (errors.keyTransports)
//         setErrors((prev) => ({ ...prev, keyTransports: null }));
//     } else {
//       showCustomModal(
//         "Please enter both a name and a distance for Key Transport.",
//         "error"
//       );
//     }
//   };

//   const removeKeyTransport = (indexToRemove) => {
//     setKeyTransports((prev) =>
//       prev.filter((_, index) => index !== indexToRemove)
//     );
//   };

//   // ═══════════════════════════════════════════
//   // 🔹 SUBMIT
//   // ═══════════════════════════════════════════
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setErrors({});

//     if (!validateForm()) return;

//     setIsLoading(true);
//     const formData = new FormData();
//     formData.append("name", name);
//     formData.append("project_rera_no", reraRegistrationNo);
//     formData.append("location", location);
//     formData.append("bussiness_volume", businessVolume);
//     formData.append("description", description);
//     formData.append("youtube_links", youtubeLink);
//     formData.append("approve_authority", legality);
//     formData.append("state", state);
//     formData.append("city", city);
//     formData.append("land_mark", landmark);
//     const amenitiesArrayOfObjects = amenities.map((id) => ({ id: String(id) }));
//     formData.append("aminities", JSON.stringify(amenitiesArrayOfObjects));
//     formData.append("total_township_area", projectSize);
//     formData.append("key_transport", JSON.stringify(keyTransports));
//     formData.append("status", status);
//     formData.append("location_map", locationMap);

//     if (image1) formData.append("thumbnail", image1);
//     if (imageprojectmap) formData.append("map_pdf", imageprojectmap);

//     formData.append("project_status", projectStatus);

//     propertyChainPapers.forEach((file) => {
//       formData.append("property_chain_papers[]", file);
//     });

//     images.forEach((imageFile) => {
//       formData.append("image[]", imageFile);
//     });

//     const authToken = localStorage.getItem("token");

//     if (!authToken) {
//       showCustomModal(
//         "Authentication token not found. Please log in.",
//         "error"
//       );
//       setIsLoading(false);
//       return;
//     }

//     try {
//       const response = await fetch(`${API_URL}/project-create`, {
//         method: "POST",
//         headers: { Authorization: `Bearer ${authToken}` },
//         body: formData,
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error("Server error response:", errorText);
//         throw new Error(`Server responded with status ${response.status}`);
//       }

//       const result = await response.json();
//       if (result.success == "1" || result.status == "1") {
//         showCustomModal(
//           result.message || "Project has been created successfully!",
//           "success"
//         );
//         // Reset all fields
//         setName("");
//         setProjectSize("");
//         setStatus("active");
//         setProjectStatus("ongoing");
//         setImages([]);
//         setImage1(null);
//         setimageprojectmap(null);
//         setReraRegistrationNo("");
//         setLocation("");
//         setDescription("");
//         setLegality("");
//         setYoutubeLink("");
//         setBusinessVolume("");
//         setCity("");
//         setState("");
//         setLandmark("");
//         setAmenities([]);
//         setPropertyChainPapers([]);
//         setSelectedStateId("");
//         setKeyTransports([]);
//         setNewTransportName("");
//         setNewTransportDistance("");
//         setLocationMap("");

//         if (imageInputRef.current) imageInputRef.current.value = "";
//         if (imageInputRef1.current) imageInputRef1.current.value = "";
//         if (imageInputRef2.current) imageInputRef2.current.value = "";
//         if (propertyChainPaperRef.current)
//           propertyChainPaperRef.current.value = "";

//         setTimeout(() => navigate("/all-project"), 3000);
//       } else {
//         const errorMessage = result.message || "Failed to create project.";
//         showCustomModal(`Error: ${errorMessage}`, "error");
//       }
//     } catch (error) {
//       console.error("Error creating project:", error);
//       showCustomModal(
//         `An unexpected error occurred: ${error.message || ""}`,
//         "error"
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // ═══════════════════════════════════════════
//   // 🎨 RENDER
//   // ═══════════════════════════════════════════
//   return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           {/* ═══════ HEADER CARD ═══════ */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "20px",
//               boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
//               border: "1.5px solid #e2e8f0",
//               padding: "24px 30px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//               position: "relative",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 position: "absolute",
//                 top: 0,
//                 left: 0,
//                 right: 0,
//                 height: "5px",
//                 background:
//                   "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div
//               style={{
//                 width: "56px",
//                 height: "56px",
//                 borderRadius: "16px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "26px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               🏗️
//             </div>
//             <div style={{ flex: 1, minWidth: "200px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 Create New Project
//               </h1>
//               <p
//                 style={{
//                   margin: "3px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 Fill in the details below to add a new project
//               </p>
//             </div>

//             <button
//               type="button"
//               onClick={() => navigate("/all-project")}
//               style={{
//                 padding: "10px 20px",
//                 borderRadius: "10px",
//                 border: "1.5px solid #e2e8f0",
//                 background: "#ffffff",
//                 color: "#1e5799",
//                 fontSize: "13px",
//                 fontWeight: "700",
//                 cursor: "pointer",
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: "8px",
//                 transition: "all 0.2s ease",
//                 boxShadow: "0 2px 8px rgba(30, 87, 153, 0.06)",
//               }}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.background = "#f0f6ff";
//                 e.currentTarget.style.borderColor = "#1e5799";
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.background = "#ffffff";
//                 e.currentTarget.style.borderColor = "#e2e8f0";
//               }}
//             >
//               <FaArrowLeft size={12} /> Back
//             </button>
//           </div>

//           {/* ═══════ MAIN CARD ═══════ */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "20px",
//               boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "30px" }}>
//               <Form onSubmit={handleSubmit}>
//                 {/* ═══════ SECTION: BASIC INFO ═══════ */}
//                 <div style={sectionHeaderStyle}>
//                   <div style={sectionIconStyle}>
//                     <FaBuilding />
//                   </div>
//                   <h6 style={sectionTitleStyle}>Basic Information</h6>
//                 </div>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label style={labelStyle}>
//                         Project Name{" "}
//                         <span style={{ color: "#dc2626" }}>*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="text"
//                         value={name}
//                         onChange={(e) => {
//                           setName(e.target.value);
//                           if (errors.name)
//                             setErrors((prev) => ({ ...prev, name: null }));
//                         }}
//                         placeholder="e.g., Grand Residency"
//                         isInvalid={!!errors.name}
//                         style={inputStyle}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.name}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label style={labelStyle}>
//                         Total Townships (Sq. Yard){" "}
//                         <span style={{ color: "#dc2626" }}>*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="number"
//                         value={projectSize}
//                         onChange={(e) => {
//                           setProjectSize(e.target.value);
//                           if (errors.projectSize)
//                             setErrors((prev) => ({
//                               ...prev,
//                               projectSize: null,
//                             }));
//                         }}
//                         placeholder="e.g., 10000"
//                         step="1"
//                         min="0"
//                         isInvalid={!!errors.projectSize}
//                         style={inputStyle}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.projectSize}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label style={labelStyle}>
//                         Project RERA Number{" "}
//                         <span style={{ color: "#dc2626" }}>*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="text"
//                         value={reraRegistrationNo}
//                         onChange={(e) => {
//                           setReraRegistrationNo(e.target.value);
//                           if (errors.reraRegistrationNo)
//                             setErrors((prev) => ({
//                               ...prev,
//                               reraRegistrationNo: null,
//                             }));
//                         }}
//                         placeholder="Enter RERA registration number"
//                         isInvalid={!!errors.reraRegistrationNo}
//                         style={inputStyle}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.reraRegistrationNo}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label style={labelStyle}>
//                         Location <span style={{ color: "#dc2626" }}>*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="text"
//                         value={location}
//                         onChange={(e) => {
//                           setLocation(e.target.value);
//                           if (errors.location)
//                             setErrors((prev) => ({
//                               ...prev,
//                               location: null,
//                             }));
//                         }}
//                         placeholder="Enter project location"
//                         isInvalid={!!errors.location}
//                         style={inputStyle}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.location}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label style={labelStyle}>
//                         Location Map Link{" "}
//                         <span style={{ color: "#dc2626" }}>*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="url"
//                         value={locationMap}
//                         onChange={(e) => {
//                           setLocationMap(e.target.value);
//                           if (errors.locationMap)
//                             setErrors((prev) => ({
//                               ...prev,
//                               locationMap: null,
//                             }));
//                         }}
//                         placeholder="Enter Google Maps or location link"
//                         isInvalid={!!errors.locationMap}
//                         style={inputStyle}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.locationMap}
//                       </Form.Control.Feedback>
//                       <Form.Text
//                         style={{
//                           color: "#64748b",
//                           fontSize: "11.5px",
//                           fontWeight: "500",
//                         }}
//                       >
//                         Enter the URL for the project location map
//                       </Form.Text>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label style={labelStyle}>
//                         Business Volume(%){" "}
//                         <span style={{ color: "#94a3b8" }}>(Optional)</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="number"
//                         value={businessVolume}
//                         onChange={(e) => {
//                           setBusinessVolume(e.target.value);
//                           if (errors.businessVolume)
//                             setErrors((prev) => ({
//                               ...prev,
//                               businessVolume: null,
//                             }));
//                         }}
//                         placeholder="Enter business volume"
//                         isInvalid={!!errors.businessVolume}
//                         style={inputStyle}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.businessVolume}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 {/* ═══════ SECTION: LOCATION ═══════ */}
//                 <div style={sectionHeaderStyle}>
//                   <div style={sectionIconStyle}>
//                     <FaMapMarkerAlt />
//                   </div>
//                   <h6 style={sectionTitleStyle}>Location Details</h6>
//                 </div>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label style={labelStyle}>
//                         State <span style={{ color: "#dc2626" }}>*</span>
//                       </Form.Label>
//                       <Form.Select
//                         value={state}
//                         onChange={(e) => {
//                           setState(e.target.value);
//                           setSelectedStateId(e.target.value);
//                           setCity("");
//                           if (errors.state)
//                             setErrors((prev) => ({ ...prev, state: null }));
//                           if (errors.city)
//                             setErrors((prev) => ({ ...prev, city: null }));
//                         }}
//                         isInvalid={!!errors.state}
//                         style={inputStyle}
//                       >
//                         <option value="">Select State</option>
//                         {statesList.map((s) => (
//                           <option key={s.id} value={s.id}>
//                             {s.name}
//                           </option>
//                         ))}
//                       </Form.Select>
//                       <Form.Control.Feedback type="invalid">
//                         {errors.state}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label style={labelStyle}>
//                         City <span style={{ color: "#dc2626" }}>*</span>
//                       </Form.Label>
//                       <Form.Select
//                         value={city}
//                         onChange={(e) => {
//                           setCity(e.target.value);
//                           if (errors.city)
//                             setErrors((prev) => ({ ...prev, city: null }));
//                         }}
//                         isInvalid={!!errors.city}
//                         disabled={!selectedStateId || citiesList.length === 0}
//                         style={{
//                           ...inputStyle,
//                           background:
//                             !selectedStateId || citiesList.length === 0
//                               ? "#f8fafc"
//                               : "#ffffff",
//                           cursor:
//                             !selectedStateId || citiesList.length === 0
//                               ? "not-allowed"
//                               : "pointer",
//                         }}
//                       >
//                         <option value="">Select City</option>
//                         {citiesList.map((c) => (
//                           <option key={c.id} value={c.id}>
//                             {c.name}
//                           </option>
//                         ))}
//                       </Form.Select>
//                       <Form.Control.Feedback type="invalid">
//                         {errors.city}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label style={labelStyle}>
//                         Landmark <span style={{ color: "#dc2626" }}>*</span>
//                       </Form.Label>
//                       <Form.Control
//                         type="text"
//                         value={landmark}
//                         onChange={(e) => {
//                           setLandmark(e.target.value);
//                           if (errors.landmark)
//                             setErrors((prev) => ({
//                               ...prev,
//                               landmark: null,
//                             }));
//                         }}
//                         placeholder="Enter nearest landmark"
//                         isInvalid={!!errors.landmark}
//                         style={inputStyle}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.landmark}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 {/* ═══════ SECTION: AMENITIES & TRANSPORT ═══════ */}
//                 <div style={sectionHeaderStyle}>
//                   <div style={sectionIconStyle}>
//                     <FaCheckCircle />
//                   </div>
//                   <h6 style={sectionTitleStyle}>
//                     Amenities & Transport
//                   </h6>
//                 </div>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label style={labelStyle}>
//                         Amenities <span style={{ color: "#dc2626" }}>*</span>
//                       </Form.Label>
//                       <Dropdown
//                         className={errors?.amenities ? "is-invalid" : ""}
//                       >
//                         <Dropdown.Toggle
//                           variant="transparent"
//                           id="dropdown-amenities"
//                           className="w-100 text-start"
//                           style={{
//                             ...inputStyle,
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "space-between",
//                             borderColor: errors?.amenities
//                               ? "#dc2626"
//                               : "#e2e8f0",
//                           }}
//                         >
//                           {amenities.length > 0
//                             ? `${amenities.length} selected`
//                             : "Select Amenities"}
//                         </Dropdown.Toggle>

//                         <Dropdown.Menu
//                           style={{
//                             maxHeight: "200px",
//                             overflowY: "auto",
//                             width: "100%",
//                             borderRadius: "12px",
//                             boxShadow:
//                               "0 12px 40px rgba(30, 87, 153, 0.15)",
//                             border: "1.5px solid #e2e8f0",
//                           }}
//                         >
//                           {availableAmenities.map((amenity) => (
//                             <Form.Check
//                               key={amenity.id}
//                               type="checkbox"
//                               id={`amenity-${amenity.id}`}
//                               label={amenity.name}
//                               checked={amenities.includes(amenity.id)}
//                               onChange={() =>
//                                 handleAmenityToggle(amenity.id)
//                               }
//                               className="mx-3 my-1 d-flex gap-2 align-items-center"
//                               style={{
//                                 fontSize: "13px",
//                                 fontWeight: "500",
//                                 color: "#1e3a5f",
//                               }}
//                             />
//                           ))}
//                         </Dropdown.Menu>
//                       </Dropdown>
//                       {errors.amenities && (
//                         <div
//                           style={{
//                             color: "#dc2626",
//                             fontSize: "12px",
//                             marginTop: "4px",
//                             fontWeight: "600",
//                           }}
//                         >
//                           {errors.amenities}
//                         </div>
//                       )}
//                       <Form.Text
//                         style={{
//                           color: "#64748b",
//                           fontSize: "11.5px",
//                           fontWeight: "500",
//                         }}
//                       >
//                         Click to select amenities
//                       </Form.Text>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label style={labelStyle}>
//                         Property Chain Papers (PDF)
//                       </Form.Label>
//                       <Form.Control
//                         type="file"
//                         accept="application/pdf"
//                         multiple
//                         onChange={handlePropertyChainPaperChange}
//                         isInvalid={!!errors.propertyChainPapers}
//                         ref={propertyChainPaperRef}
//                         style={inputStyle}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.propertyChainPapers}
//                       </Form.Control.Feedback>
//                       {propertyChainPapers.length > 0 && (
//                         <div
//                           style={{
//                             marginTop: "10px",
//                             display: "flex",
//                             flexWrap: "wrap",
//                             gap: "8px",
//                           }}
//                         >
//                           {propertyChainPapers.map((file, index) => (
//                             <div
//                               key={index}
//                               style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: "8px",
//                                 padding: "8px 12px",
//                                 borderRadius: "10px",
//                                 background:
//                                   "linear-gradient(135deg, #feeaeb, #fecaca)",
//                                 border: "1.5px solid #fca5a5",
//                                 maxWidth: "100%",
//                               }}
//                             >
//                               <FaFilePdf
//                                 size={14}
//                                 style={{ color: "#dc2626", flexShrink: 0 }}
//                               />
//                               <span
//                                 style={{
//                                   fontSize: "12px",
//                                   color: "#991b1b",
//                                   fontWeight: "600",
//                                   maxWidth: "140px",
//                                   overflow: "hidden",
//                                   textOverflow: "ellipsis",
//                                   whiteSpace: "nowrap",
//                                 }}
//                                 title={file.name}
//                               >
//                                 {file.name}
//                               </span>
//                               <button
//                                 type="button"
//                                 onClick={() =>
//                                   removePropertyChainPaper(index)
//                                 }
//                                 style={{
//                                   width: "20px",
//                                   height: "20px",
//                                   borderRadius: "50%",
//                                   border: "none",
//                                   background: "#dc2626",
//                                   color: "#ffffff",
//                                   fontSize: "10px",
//                                   fontWeight: "700",
//                                   cursor: "pointer",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center",
//                                   flexShrink: 0,
//                                 }}
//                               >
//                                 ×
//                               </button>
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 {/* Key Transport */}
//                 <Form.Group className="mb-3">
//                   <Form.Label style={labelStyle}>
//                     Key Transport <span style={{ color: "#dc2626" }}>*</span>
//                   </Form.Label>
//                   <Row className="mb-2 gy-2">
//                     <Col md={5}>
//                       <Form.Control
//                         type="text"
//                         placeholder="e.g., Malls"
//                         value={newTransportName}
//                         onChange={(e) => setNewTransportName(e.target.value)}
//                         isInvalid={
//                           !!errors.keyTransports &&
//                           keyTransports.length === 0
//                         }
//                         style={inputStyle}
//                       />
//                     </Col>
//                     <Col md={5}>
//                       <Form.Control
//                         type="text"
//                         placeholder="e.g., 2KM, 190m"
//                         value={newTransportDistance}
//                         onChange={(e) =>
//                           setNewTransportDistance(e.target.value)
//                         }
//                         isInvalid={
//                           !!errors.keyTransports &&
//                           keyTransports.length === 0
//                         }
//                         style={inputStyle}
//                       />
//                     </Col>
//                     <Col md={2} className="d-grid">
//                       <button
//                         type="button"
//                         onClick={addKeyTransport}
//                         style={{
//                           padding: "10px 16px",
//                           borderRadius: "10px",
//                           border: "none",
//                           background:
//                             "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                           color: "#ffffff",
//                           fontSize: "13px",
//                           fontWeight: "700",
//                           cursor: "pointer",
//                           display: "inline-flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           gap: "6px",
//                           boxShadow:
//                             "0 4px 12px rgba(30, 87, 153, 0.3)",
//                         }}
//                       >
//                         <FaPlus size={11} /> Add
//                       </button>
//                     </Col>
//                   </Row>
//                   {errors.keyTransports && (
//                     <div
//                       style={{
//                         color: "#dc2626",
//                         fontSize: "12px",
//                         marginBottom: "8px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       {errors.keyTransports}
//                     </div>
//                   )}

//                   {keyTransports.length > 0 && (
//                     <div
//                       style={{
//                         marginTop: "10px",
//                         border: "1.5px solid #e2e8f0",
//                         borderRadius: "12px",
//                         padding: "14px",
//                         background: "#f8fafc",
//                       }}
//                     >
//                       <h6
//                         style={{
//                           margin: "0 0 10px",
//                           fontSize: "12px",
//                           fontWeight: "800",
//                           color: "#1e5799",
//                           textTransform: "uppercase",
//                           letterSpacing: "0.3px",
//                         }}
//                       >
//                         Added Locations:
//                       </h6>
//                       <ul
//                         style={{
//                           listStyle: "none",
//                           padding: 0,
//                           margin: 0,
//                         }}
//                       >
//                         {keyTransports.map((item, index) => (
//                           <li
//                             key={index}
//                             style={{
//                               display: "flex",
//                               justifyContent: "space-between",
//                               alignItems: "center",
//                               padding: "8px 12px",
//                               borderRadius: "8px",
//                               background: "#ffffff",
//                               border: "1.5px solid #e2e8f0",
//                               marginBottom: "6px",
//                             }}
//                           >
//                             <span
//                               style={{
//                                 fontSize: "13px",
//                                 color: "#1e3a5f",
//                               }}
//                             >
//                               <strong style={{ color: "#1e5799" }}>
//                                 {item.name}:
//                               </strong>{" "}
//                               {item.distance}
//                             </span>
//                             <button
//                               type="button"
//                               onClick={() => removeKeyTransport(index)}
//                               style={{
//                                 padding: "4px 10px",
//                                 borderRadius: "8px",
//                                 border: "1.5px solid #fca5a5",
//                                 background: "#feeaeb",
//                                 color: "#dc2626",
//                                 fontSize: "11.5px",
//                                 fontWeight: "700",
//                                 cursor: "pointer",
//                                 display: "inline-flex",
//                                 alignItems: "center",
//                                 gap: "4px",
//                               }}
//                             >
//                               <FaTrash size={10} /> Remove
//                             </button>
//                           </li>
//                         ))}
//                       </ul>
//                     </div>
//                   )}
//                 </Form.Group>

//                 {/* ═══════ SECTION: MEDIA & DESCRIPTION ═══════ */}
//                 <div style={sectionHeaderStyle}>
//                   <div style={sectionIconStyle}>
//                     <FaImage />
//                   </div>
//                   <h6 style={sectionTitleStyle}>Media & Description</h6>
//                 </div>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label style={labelStyle}>
//                         Status <span style={{ color: "#dc2626" }}>*</span>
//                       </Form.Label>
//                       <Form.Select
//                         value={status}
//                         onChange={(e) => setStatus(e.target.value)}
//                         style={inputStyle}
//                       >
//                         <option value="active">Show</option>
//                         <option value="inactive">Hide</option>
//                       </Form.Select>
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label style={labelStyle}>
//                         Project Status{" "}
//                         <span style={{ color: "#dc2626" }}>*</span>
//                       </Form.Label>
//                       <Form.Select
//                         value={projectStatus}
//                         onChange={(e) => {
//                           setProjectStatus(e.target.value);
//                           if (errors.projectStatus)
//                             setErrors((prev) => ({
//                               ...prev,
//                               projectStatus: null,
//                             }));
//                         }}
//                         isInvalid={!!errors.projectStatus}
//                         style={inputStyle}
//                       >
//                         <option value="ongoing">Ongoing Project</option>
//                         <option value="complete">Complete Project</option>
//                       </Form.Select>
//                       <Form.Control.Feedback type="invalid">
//                         {errors.projectStatus}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Form.Group className="mb-3">
//                   <Form.Label style={labelStyle}>
//                     Description <span style={{ color: "#dc2626" }}>*</span>
//                   </Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     rows={3}
//                     value={description}
//                     onChange={(e) => {
//                       setDescription(e.target.value);
//                       if (errors.description)
//                         setErrors((prev) => ({
//                           ...prev,
//                           description: null,
//                         }));
//                     }}
//                     placeholder="Enter Description"
//                     isInvalid={!!errors.description}
//                     style={{ ...inputStyle, resize: "vertical" }}
//                   />
//                   {errors.description && (
//                     <div
//                       style={{
//                         color: "#dc2626",
//                         fontSize: "12px",
//                         marginTop: "4px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       {errors.description}
//                     </div>
//                   )}
//                 </Form.Group>

//                 <Form.Group className="mb-3">
//                   <Form.Label style={labelStyle}>
//                     Approved Authority{" "}
//                     <span style={{ color: "#dc2626" }}>*</span>
//                   </Form.Label>
//                   <Form.Control
//                     as="textarea"
//                     rows={3}
//                     value={legality}
//                     onChange={(e) => {
//                       setLegality(e.target.value);
//                       if (errors.legality)
//                         setErrors((prev) => ({ ...prev, legality: null }));
//                     }}
//                     placeholder="Enter legality details"
//                     isInvalid={!!errors.legality}
//                     style={{ ...inputStyle, resize: "vertical" }}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {errors.legality}
//                   </Form.Control.Feedback>
//                 </Form.Group>

//                 <Form.Group className="mb-3">
//                   <Form.Label style={labelStyle}>
//                     Project Images (Multiple)
//                   </Form.Label>
//                   <Form.Control
//                     type="file"
//                     accept="image/*"
//                     multiple
//                     onChange={handleImageChange}
//                     isInvalid={!!errors.images}
//                     ref={imageInputRef}
//                     style={inputStyle}
//                   />
//                   <Form.Control.Feedback type="invalid">
//                     {errors.images}
//                   </Form.Control.Feedback>
//                   {images.length > 0 && (
//                     <div
//                       style={{
//                         marginTop: "10px",
//                         display: "flex",
//                         flexWrap: "wrap",
//                         gap: "10px",
//                       }}
//                     >
//                       {images.map((file, index) => (
//                         <div
//                           key={index}
//                           style={{
//                             position: "relative",
//                             width: "100px",
//                             height: "100px",
//                           }}
//                         >
//                           <img
//                             src={URL.createObjectURL(file)}
//                             alt={`Preview ${index}`}
//                             style={{
//                               width: "100%",
//                               height: "100%",
//                               objectFit: "cover",
//                               borderRadius: "10px",
//                               border: "1.5px solid #e2e8f0",
//                             }}
//                           />
//                           <button
//                             type="button"
//                             onClick={() => removeImage(index)}
//                             style={{
//                               position: "absolute",
//                               top: "-6px",
//                               right: "-6px",
//                               width: "22px",
//                               height: "22px",
//                               borderRadius: "50%",
//                               border: "none",
//                               background: "#dc2626",
//                               color: "#ffffff",
//                               fontSize: "12px",
//                               fontWeight: "700",
//                               cursor: "pointer",
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
//                             }}
//                           >
//                             ×
//                           </button>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                   {images.length > 0 && (
//                     <div
//                       style={{
//                         marginTop: "8px",
//                         fontSize: "11.5px",
//                         color: "#64748b",
//                         fontWeight: "600",
//                       }}
//                     >
//                       {images.length} images selected
//                     </div>
//                   )}
//                 </Form.Group>

//                 <Row>
//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label style={labelStyle}>
//                         Thumbnail Image
//                       </Form.Label>
//                       <Form.Control
//                         type="file"
//                         accept="image/*"
//                         onChange={handleImageChange1}
//                         isInvalid={!!errors.image1}
//                         ref={imageInputRef1}
//                         style={inputStyle}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.image1}
//                       </Form.Control.Feedback>
//                       {image1 && (
//                         <div
//                           style={{
//                             marginTop: "10px",
//                             position: "relative",
//                             display: "inline-block",
//                             width: "100px",
//                             height: "100px",
//                           }}
//                         >
//                           <img
//                             src={URL.createObjectURL(image1)}
//                             alt="Thumbnail Preview"
//                             style={{
//                               width: "100%",
//                               height: "100%",
//                               objectFit: "cover",
//                               borderRadius: "10px",
//                               border: "1.5px solid #22c55e",
//                             }}
//                           />
//                           <button
//                             type="button"
//                             onClick={removeImage1}
//                             style={{
//                               position: "absolute",
//                               top: "-6px",
//                               right: "-6px",
//                               width: "22px",
//                               height: "22px",
//                               borderRadius: "50%",
//                               border: "none",
//                               background: "#dc2626",
//                               color: "#ffffff",
//                               fontSize: "12px",
//                               fontWeight: "700",
//                               cursor: "pointer",
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
//                             }}
//                           >
//                             ×
//                           </button>
//                         </div>
//                       )}
//                     </Form.Group>
//                   </Col>

//                   <Col md={6}>
//                     <Form.Group className="mb-3">
//                       <Form.Label style={labelStyle}>
//                         Project Map (PDF)
//                       </Form.Label>
//                       <Form.Control
//                         type="file"
//                         accept="application/pdf"
//                         onChange={handleImageChange2}
//                         isInvalid={!!errors.imageprojectmap}
//                         ref={imageInputRef2}
//                         style={inputStyle}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.imageprojectmap}
//                       </Form.Control.Feedback>
//                       {imageprojectmap && (
//                         <div
//                           style={{
//                             marginTop: "10px",
//                             display: "inline-flex",
//                             alignItems: "center",
//                             gap: "8px",
//                             padding: "10px 14px",
//                             borderRadius: "10px",
//                             background:
//                               "linear-gradient(135deg, #feeaeb, #fecaca)",
//                             border: "1.5px solid #fca5a5",
//                           }}
//                         >
//                           <FaFilePdf
//                             size={14}
//                             style={{ color: "#dc2626" }}
//                           />
//                           <span
//                             style={{
//                               fontSize: "12px",
//                               color: "#991b1b",
//                               fontWeight: "600",
//                               maxWidth: "160px",
//                               overflow: "hidden",
//                               textOverflow: "ellipsis",
//                               whiteSpace: "nowrap",
//                             }}
//                             title={imageprojectmap.name}
//                           >
//                             {imageprojectmap.name}
//                           </span>
//                           <button
//                             type="button"
//                             onClick={removeImage2}
//                             style={{
//                               width: "20px",
//                               height: "20px",
//                               borderRadius: "50%",
//                               border: "none",
//                               background: "#dc2626",
//                               color: "#ffffff",
//                               fontSize: "10px",
//                               fontWeight: "700",
//                               cursor: "pointer",
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               flexShrink: 0,
//                             }}
//                           >
//                             ×
//                           </button>
//                         </div>
//                       )}
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 <Form.Group className="mb-3">
//                   <Form.Label style={labelStyle}>
//                     Youtube Link
//                   </Form.Label>
//                   <Form.Control
//                     type="text"
//                     value={youtubeLink}
//                     onChange={(e) => {
//                       setYoutubeLink(e.target.value);
//                       if (errors.youtubeLink)
//                         setErrors((prev) => ({
//                           ...prev,
//                           youtubeLink: null,
//                         }));
//                     }}
//                     placeholder="Enter Your Youtube Link"
//                     isInvalid={!!errors.youtubeLink}
//                     style={inputStyle}
//                   />
//                   {errors.youtubeLink && (
//                     <div
//                       style={{
//                         color: "#dc2626",
//                         fontSize: "12px",
//                         marginTop: "4px",
//                         fontWeight: "600",
//                       }}
//                     >
//                       {errors.youtubeLink}
//                     </div>
//                   )}
//                 </Form.Group>

//                 {/* ═══════ SUBMIT BUTTON ═══════ */}
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "flex-end",
//                     paddingTop: "24px",
//                     borderTop: "1.5px dashed #e2e8f0",
//                     marginTop: "16px",
//                   }}
//                 >
//                   <button
//                     type="submit"
//                     disabled={isLoading}
//                     style={{
//                       padding: "14px 46px",
//                       borderRadius: "12px",
//                       border: "none",
//                       background: isLoading
//                         ? "#cbd5e1"
//                         : "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                       color: "#ffffff",
//                       fontSize: "14.5px",
//                       fontWeight: "800",
//                       letterSpacing: "0.5px",
//                       cursor: isLoading ? "not-allowed" : "pointer",
//                       transition: "all 0.3s ease",
//                       boxShadow: isLoading
//                         ? "none"
//                         : "0 8px 24px rgba(30, 87, 153, 0.35)",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       gap: "10px",
//                       minWidth: "230px",
//                     }}
//                     onMouseEnter={(e) => {
//                       if (!isLoading) {
//                         e.currentTarget.style.transform =
//                           "translateY(-2px)";
//                         e.currentTarget.style.boxShadow =
//                           "0 12px 32px rgba(30, 87, 153, 0.45)";
//                       }
//                     }}
//                     onMouseLeave={(e) => {
//                       if (!isLoading) {
//                         e.currentTarget.style.transform = "translateY(0)";
//                         e.currentTarget.style.boxShadow =
//                           "0 8px 24px rgba(30, 87, 153, 0.35)";
//                       }
//                     }}
//                   >
//                     {isLoading ? (
//                       <>
//                         <span
//                           style={{
//                             width: "16px",
//                             height: "16px",
//                             border: "2px solid rgba(255,255,255,0.3)",
//                             borderTop: "2px solid #ffffff",
//                             borderRadius: "50%",
//                             display: "inline-block",
//                             animation: "spin 0.8s linear infinite",
//                           }}
//                         />
//                         Creating...
//                       </>
//                     ) : (
//                       <>
//                         <FaSave size={14} /> Create Project
//                       </>
//                     )}
//                   </button>
//                 </div>

//                 <div
//                   style={{
//                     marginTop: "20px",
//                     paddingTop: "20px",
//                     borderTop: "1.5px dashed #e2e8f0",
//                     textAlign: "center",
//                   }}
//                 >
//                   <p
//                     style={{
//                       margin: 0,
//                       fontSize: "12.5px",
//                       color: "#94a3b8",
//                       fontWeight: "500",
//                     }}
//                   >
//                     🔒 All fields marked with{" "}
//                     <span style={{ color: "#dc2626", fontWeight: "800" }}>
//                       *
//                     </span>{" "}
//                     are required
//                   </p>
//                 </div>
//               </Form>
//             </div>
//           </div>

//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>

//       {/* ═══════ MESSAGE MODAL ═══════ */}
//       {/* {showModal && (
//         <div
//           className="modal d-block"
//           tabIndex="-1"
//           style={{
//             backgroundColor: "rgba(15, 23, 42, 0.6)",
//             backdropFilter: "blur(4px)",
//             zIndex: 99999,
//           }}
//         >
//           <div className="modal-dialog modal-dialog-centered">
//             <div
//               style={{
//                 background: "#ffffff",
//                 borderRadius: "20px",
//                 overflow: "hidden",
//                 border: "none",
//                 boxShadow: "0 24px 60px rgba(0,0,0,0.2)",
//               }}
//             >
//               <div
//                 style={{
//                   height: "5px",
//                   background:
//                     modalType === "success"
//                       ? "linear-gradient(90deg, #059669, #10b981)"
//                       : "linear-gradient(90deg, #dc2626, #ef4444)",
//                 }}
//               />

//               <div
//                 style={{
//                   padding: "24px 24px 16px",
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "14px",
//                 }}
//               >
//                 <div
//                   style={{
//                     width: "48px",
//                     height: "48px",
//                     borderRadius: "14px",
//                     background:
//                       modalType === "success"
//                         ? "linear-gradient(135deg, #f0fdf4, #dcfce7)"
//                         : "linear-gradient(135deg, #feeaeb, #fecaca)",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     fontSize: "22px",
//                     flexShrink: 0,
//                     color:
//                       modalType === "success" ? "#059669" : "#dc2626",
//                   }}
//                 >
//                   {modalType === "success" ? (
//                     <FaCheckCircle />
//                   ) : (
//                     <FaTimesCircle />
//                   )}
//                 </div>
//                 <div style={{ flex: 1 }}>
//                   <h5
//                     style={{
//                       margin: 0,
//                       fontSize: "16px",
//                       fontWeight: "800",
//                       color:
//                         modalType === "success" ? "#059669" : "#dc2626",
//                     }}
//                   >
//                     {modalType === "success" ? "Success!" : "Error!"}
//                   </h5>
//                 </div>
//                 <button
//                   type="button"
//                   onClick={closeCustomModal}
//                   style={{
//                     width: "32px",
//                     height: "32px",
//                     borderRadius: "10px",
//                     border: "1.5px solid #e2e8f0",
//                     background: "#ffffff",
//                     color: "#64748b",
//                     fontSize: "16px",
//                     cursor: "pointer",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     flexShrink: 0,
//                   }}
//                 >
//                   ×
//                 </button>
//               </div>

//               <div
//                 style={{
//                   padding: "0 24px 24px 86px",
//                   fontSize: "13.5px",
//                   color: "#334155",
//                   fontWeight: "500",
//                   lineHeight: "1.6",
//                 }}
//               >
//                 {modalMessage}
//               </div>

//               <div
//                 style={{
//                   padding: "16px 24px",
//                   background: "#f8fafc",
//                   borderTop: "1.5px solid #e2e8f0",
//                   display: "flex",
//                   justifyContent: "center",
//                 }}
//               >
//                 <button
//                   type="button"
//                   onClick={closeCustomModal}
//                   style={{
//                     padding: "10px 36px",
//                     borderRadius: "10px",
//                     border: "none",
//                     background:
//                       modalType === "success"
//                         ? "linear-gradient(135deg, #059669, #10b981)"
//                         : "linear-gradient(135deg, #dc2626, #ef4444)",
//                     color: "#ffffff",
//                     fontSize: "13.5px",
//                     fontWeight: "800",
//                     cursor: "pointer",
//                     boxShadow:
//                       modalType === "success"
//                         ? "0 4px 14px rgba(5, 150, 105, 0.3)"
//                         : "0 4px 14px rgba(220, 38, 38, 0.3)",
//                   }}
//                 >
//                   OK
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )} */}



//       {/* ═══════ MESSAGE MODAL ═══════ */}
// {showModal && (
//   <div
//     onClick={closeCustomModal}   // ✅ Backdrop click pe close
//     style={{
//       position: "fixed",          // ✅ Fixed positioning (important)
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       backgroundColor: "rgba(15, 23, 42, 0.55)",
//       backdropFilter: "blur(4px)",
//       zIndex: 99999,
//       display: "flex",            // ✅ Flexbox centering
//       alignItems: "center",
//       justifyContent: "center",
//       padding: "20px",
//     }}
//   >
//     <div
//       onClick={(e) => e.stopPropagation()}  // ✅ Modal ke andar click pe close na ho
//       style={{
//         background: "#ffffff",
//         borderRadius: "16px",
//         overflow: "hidden",
//         border: "none",
//         boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
//         maxWidth: "460px",
//         width: "100%",
//       }}
//     >
//       {/* Top Color Strip — Blue Theme */}
//       <div
//         style={{
//           height: "5px",
//           background: "linear-gradient(135deg, #2b6cb0, #1e5799)",
//         }}
//       />

//       {/* Header */}
//       <div
//         style={{
//           padding: "22px 22px 14px",
//           display: "flex",
//           alignItems: "center",
//           gap: "14px",
//         }}
//       >
//         {/* Icon — Blue Theme */}
//         <div
//           style={{
//             width: "46px",
//             height: "46px",
//             borderRadius: "12px",
//             background: "linear-gradient(135deg, #e8f1fb, #dbeafe)",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             fontSize: "20px",
//             flexShrink: 0,
//             color: "#1e5799",
//           }}
//         >
//           {modalType === "success" ? <FaCheckCircle /> : <FaTimesCircle />}
//         </div>

//         {/* Title — Blue Theme */}
//         <div style={{ flex: 1 }}>
//           <h5
//             style={{
//               margin: 0,
//               fontSize: "17px",
//               fontWeight: "800",
//               color: "#1e5799",
//               letterSpacing: "-0.2px",
//             }}
//           >
//             {modalType === "success" ? "Success!" : "Error!"}
//           </h5>
//         </div>

//         {/* ✅ Close Button — FIXED */}
//         <button
//           type="button"
//           onClick={(e) => {
//             e.preventDefault();
//             e.stopPropagation();
//             closeCustomModal();
//           }}
//           style={{
//             width: "34px",
//             height: "34px",
//             borderRadius: "8px",
//             border: "1.5px solid #e2e8f0",
//             background: "#ffffff",
//             color: "#64748b",
//             fontSize: "16px",
//             fontWeight: "700",
//             cursor: "pointer",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             flexShrink: 0,
//             transition: "all 0.2s ease",
//             padding: 0,
//             lineHeight: 1,
//           }}
//           onMouseEnter={(e) => {
//             e.currentTarget.style.background = "#f0f6ff";
//             e.currentTarget.style.color = "#1e5799";
//             e.currentTarget.style.borderColor = "#1e5799";
//           }}
//           onMouseLeave={(e) => {
//             e.currentTarget.style.background = "#ffffff";
//             e.currentTarget.style.color = "#64748b";
//             e.currentTarget.style.borderColor = "#e2e8f0";
//           }}
//         >
//           ✕
//         </button>
//       </div>

//       {/* Body Message */}
//       <div
//         style={{
//           padding: "0 22px 22px 82px",
//           fontSize: "13.5px",
//           color: "#475569",
//           fontWeight: "500",
//           lineHeight: "1.6",
//         }}
//       >
//         {modalMessage}
//       </div>

//       {/* Footer Button — Blue Theme */}
//       <div
//         style={{
//           padding: "16px 22px",
//           background: "#f8fafc",
//           borderTop: "1px solid #e2e8f0",
//           display: "flex",
//           justifyContent: "center",
//         }}
//       >
//         <button
//           type="button"
//           onClick={(e) => {
//             e.preventDefault();
//             e.stopPropagation();
//             closeCustomModal();
//           }}
//           style={{
//             padding: "11px 48px",
//             borderRadius: "10px",
//             border: "none",
//             background: "linear-gradient(135deg, #2b6cb0, #1e5799)",
//             color: "#ffffff",
//             fontSize: "14px",
//             fontWeight: "800",
//             cursor: "pointer",
//             letterSpacing: "0.3px",
//             boxShadow: "0 6px 18px rgba(30, 87, 153, 0.35)",
//             transition: "all 0.2s ease",
//           }}
//           onMouseEnter={(e) => {
//             e.currentTarget.style.transform = "translateY(-1px)";
//             e.currentTarget.style.boxShadow =
//               "0 10px 24px rgba(30, 87, 153, 0.45)";
//           }}
//           onMouseLeave={(e) => {
//             e.currentTarget.style.transform = "translateY(0)";
//             e.currentTarget.style.boxShadow =
//               "0 6px 18px rgba(30, 87, 153, 0.35)";
//           }}
//         >
//           OK
//         </button>
//       </div>
//     </div>
//   </div>
// )}

//       <style>{`
//         @keyframes spin {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }
//       `}</style>
//     </>
//   );
// }

// export default CreateProject;
import React, { useState, useEffect, useRef } from "react";
import {
  Form,
  Button,
  Row,
  Col,
  Modal,
  Dropdown,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  FaBuilding,
  FaMapMarkerAlt,
  FaImage,
  FaFilePdf,
  FaYoutube,
  FaCheckCircle,
  FaTimesCircle,
  FaTrash,
  FaPlus,
  FaInfoCircle,
  FaSave,
  FaArrowLeft,
} from "react-icons/fa";

const API_URL = process.env.REACT_APP_API_URL;

// ─── Shared input style ───
const labelStyle = {
  display: "block",
  fontSize: "12.5px",
  fontWeight: "700",
  color: "#1e3a5f",
  marginBottom: "8px",       // ✅ 6 → 8
  letterSpacing: "0.2px",
};

const inputStyle = {
  width: "100%",
  padding: "12px 16px",       // ✅ 10px 14px → 12px 16px
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  fontSize: "13.5px",
  fontWeight: "500",
  color: "#1e3a5f",
  outline: "none",
  boxSizing: "border-box",
  transition: "all 0.2s ease",
  background: "#ffffff",
};

// ✅ Section header with more spacing
const sectionHeaderStyle = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  marginBottom: "24px",       // ✅ 18 → 24
  marginTop: "36px",          // ✅ 8 → 36 (sections ke beech gap)
  paddingBottom: "14px",      // ✅ 10 → 14
  borderBottom: "2px dashed #e2e8f0",
};

const sectionIconStyle = {
  width: "36px",              // ✅ 32 → 36
  height: "36px",
  borderRadius: "10px",
  background: "linear-gradient(135deg, #e8f1fb, #dbeafe)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "16px",
  flexShrink: 0,
  color: "#1e5799",
};

const sectionTitleStyle = {
  margin: 0,
  fontSize: "14px",           // ✅ 13.5 → 14
  fontWeight: "800",
  color: "#1e5799",
  letterSpacing: "0.3px",
  textTransform: "uppercase",
};

// ✅ Field group wrapper — consistent spacing
const fieldGroupStyle = {
  marginBottom: "24px",       // ✅ har field ke neeche 24px
};

function CreateProject() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [projectSize, setProjectSize] = useState("");
  const [status, setStatus] = useState("active");
  const [projectStatus, setProjectStatus] = useState("ongoing");
  const [images, setImages] = useState([]);
  const [image1, setImage1] = useState(null);
  const [imageprojectmap, setimageprojectmap] = useState(null);
  const [reraRegistrationNo, setReraRegistrationNo] = useState("");
  const [location, setLocation] = useState("");
  const [description, setDescription] = useState("");
  const [youtubeLink, setYoutubeLink] = useState("");
  const [legality, setLegality] = useState("");
  const [businessVolume, setBusinessVolume] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [landmark, setLandmark] = useState("");
  const [propertyChainPapers, setPropertyChainPapers] = useState([]);
  const [availableAmenities, setAvailableAmenities] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [selectedStateId, setSelectedStateId] = useState("");
  const [keyTransports, setKeyTransports] = useState([]);
  const [amenities, setAmenities] = useState([]);
  const [newTransportName, setNewTransportName] = useState("");
  const [newTransportDistance, setNewTransportDistance] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("success");
  const imageInputRef = useRef(null);
  const imageInputRef1 = useRef(null);
  const imageInputRef2 = useRef(null);
  const propertyChainPaperRef = useRef(null);
  const [locationMap, setLocationMap] = useState("");

  const showCustomModal = (message, type) => {
    setModalMessage(message);
    setModalType(type);
    setShowModal(true);
  };

  const closeCustomModal = () => {
    setShowModal(false);
    setModalMessage("");
    setModalType("success");
  };

  const getAuthToken = () => localStorage.getItem("token");

  // ═══════════════════════════════════════════
  // 🔹 FETCH AMENITIES
  // ═══════════════════════════════════════════
  useEffect(() => {
    const fetchAmenities = async () => {
      const token = getAuthToken();
      if (!token) {
        showCustomModal(
          "Authentication token not found. Please log in.",
          "error"
        );
        return;
      }
      try {
        const amenitiesResponse = await fetch(`${API_URL}/amenities-list`, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });
        const amenitiesData = await amenitiesResponse.json();

        if (amenitiesResponse.ok && amenitiesData.status === "1") {
          setAvailableAmenities(amenitiesData.data);
        } else {
          console.error("Failed to fetch amenities:", amenitiesData.message);
        }
      } catch (error) {
        console.error("Error fetching amenities:", error);
      }
    };
    fetchAmenities();
  }, []);

  // ═══════════════════════════════════════════
  // 🔹 FETCH STATES
  // ═══════════════════════════════════════════
  useEffect(() => {
    const fetchStates = async () => {
      const token = getAuthToken();
      if (!token) {
        showCustomModal(
          "Authentication token not found. Please log in.",
          "error"
        );
        return;
      }
      try {
        const statesResponse = await fetch(`${API_URL}/state-list`, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });
        const statesData = await statesResponse.json();

        if (statesData.status == "1") {
          setStatesList(statesData.data);
        } else {
          console.error("Failed to fetch states:", statesData.message);
        }
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };
    fetchStates();
  }, []);

  // ═══════════════════════════════════════════
  // 🔹 FETCH CITIES BY STATE
  // ═══════════════════════════════════════════
  useEffect(() => {
    const fetchCities = async () => {
      if (selectedStateId) {
        const token = getAuthToken();
        if (!token) {
          showCustomModal(
            "Authentication token not found. Please log in.",
            "error"
          );
          return;
        }

        try {
          const citiesResponse = await fetch(`${API_URL}/city-list`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ state_id: selectedStateId }),
          });
          const citiesData = await citiesResponse.json();
          if (citiesResponse.ok && citiesData.status === "1") {
            setCitiesList(citiesData.data);
          } else {
            setCitiesList([]);
            console.error("Failed to fetch cities:", citiesData.message);
          }
        } catch (error) {
          setCitiesList([]);
          console.error("Error fetching cities:", error);
        }
      } else {
        setCitiesList([]);
      }
    };

    fetchCities();
  }, [selectedStateId]);

  // ═══════════════════════════════════════════
  // 🔹 VALIDATION
  // ═══════════════════════════════════════════
  const validateForm = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "Project name is required.";
    if (!projectSize || isNaN(projectSize) || parseFloat(projectSize) <= 0) {
      newErrors.projectSize = "Project size must be a positive number.";
    }
    if (!reraRegistrationNo.trim())
      newErrors.reraRegistrationNo = "RERA Registration No. is required.";
    if (!location.trim()) newErrors.location = "Location is required.";
    if (!description.trim()) newErrors.description = "Description is required.";
    if (!legality.trim())
      newErrors.legality = "Approved Authority details are required.";
    if (!projectStatus.trim())
      newErrors.projectStatus = "Project Status is required.";
    if (!city) newErrors.city = "City is required.";
    if (!state) newErrors.state = "State is required.";
    if (!landmark.trim()) newErrors.landmark = "Landmark is required.";
    if (amenities.length === 0)
      newErrors.amenities = "At least one amenity must be selected.";
    if (keyTransports.length === 0)
      newErrors.keyTransports = "At least one Key Transport entry is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ═══════════════════════════════════════════
  // 🔹 IMAGE HANDLERS
  // ═══════════════════════════════════════════
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (images.length + files.length > 20) {
      showCustomModal(
        "You can only upload a maximum of 20 project images.",
        "error"
      );
      if (imageInputRef.current) imageInputRef.current.value = "";
      return;
    }

    setErrors((prevErrors) => ({ ...prevErrors, images: "" }));
    setImages([...images, ...files]);
    e.target.value = null;
  };

  const removeImage = (indexToRemove) => {
    setImages((prevImages) =>
      prevImages.filter((_, index) => index !== indexToRemove)
    );
    if (images.length === 1 && indexToRemove === 0) {
      if (imageInputRef.current) imageInputRef.current.value = "";
    }
  };

  const handleImageChange1 = (e) => {
    const file = e.target.files[0];
    if (file && !file.type.startsWith("image/")) {
      showCustomModal("Please upload an image file for the thumbnail.", "error");
      if (imageInputRef1.current) imageInputRef1.current.value = "";
      return;
    }
    setImage1(file);
    if (errors.image1) setErrors((prev) => ({ ...prev, image1: null }));
  };

  const removeImage1 = () => {
    setImage1(null);
    if (imageInputRef1.current) imageInputRef1.current.value = "";
  };

  const handleImageChange2 = (e) => {
    const file = e.target.files[0];
    if (file && file.type !== "application/pdf") {
      showCustomModal("Please upload a PDF file for the project map.", "error");
      if (imageInputRef2.current) imageInputRef2.current.value = "";
      return;
    }
    setimageprojectmap(file);
    if (errors.imageprojectmap)
      setErrors((prev) => ({ ...prev, imageprojectmap: null }));
  };

  const removeImage2 = () => {
    setimageprojectmap(null);
    if (imageInputRef2.current) imageInputRef2.current.value = "";
  };

  const handlePropertyChainPaperChange = (e) => {
    const files = Array.from(e.target.files);
    const newPdfs = files.filter((file) => file.type === "application/pdf");

    if (newPdfs.length !== files.length) {
      showCustomModal(
        "Only PDF files are allowed for Property Chain Papers.",
        "error"
      );
      if (propertyChainPaperRef.current)
        propertyChainPaperRef.current.value = "";
      return;
    }

    setPropertyChainPapers([...propertyChainPapers, ...newPdfs]);
    setErrors((prevErrors) => ({ ...prevErrors, propertyChainPapers: "" }));
    e.target.value = null;
  };

  const removePropertyChainPaper = (indexToRemove) => {
    setPropertyChainPapers((prevPdfs) =>
      prevPdfs.filter((_, index) => index !== indexToRemove)
    );
    if (propertyChainPapers.length === 1 && indexToRemove === 0) {
      if (propertyChainPaperRef.current)
        propertyChainPaperRef.current.value = "";
    }
  };

  // ═══════════════════════════════════════════
  // 🔹 AMENITY / TRANSPORT HANDLERS
  // ═══════════════════════════════════════════
  const handleAmenityToggle = (amenityId) => {
    const updatedAmenities = amenities.includes(amenityId)
      ? amenities.filter((id) => id !== amenityId)
      : [...amenities, amenityId];
    setAmenities(updatedAmenities);
    if (errors.amenities) setErrors((prev) => ({ ...prev, amenities: null }));
  };

  const addKeyTransport = () => {
    if (newTransportName.trim() && newTransportDistance.trim()) {
      setKeyTransports((prev) => [
        ...prev,
        {
          name: newTransportName.trim(),
          distance: newTransportDistance.trim(),
        },
      ]);
      setNewTransportName("");
      setNewTransportDistance("");
      if (errors.keyTransports)
        setErrors((prev) => ({ ...prev, keyTransports: null }));
    } else {
      showCustomModal(
        "Please enter both a name and a distance for Key Transport.",
        "error"
      );
    }
  };

  const removeKeyTransport = (indexToRemove) => {
    setKeyTransports((prev) =>
      prev.filter((_, index) => index !== indexToRemove)
    );
  };

  // ═══════════════════════════════════════════
  // 🔹 SUBMIT
  // ═══════════════════════════════════════════
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    if (!validateForm()) return;

    setIsLoading(true);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("project_rera_no", reraRegistrationNo);
    formData.append("location", location);
    formData.append("bussiness_volume", businessVolume);
    formData.append("description", description);
    formData.append("youtube_links", youtubeLink);
    formData.append("approve_authority", legality);
    formData.append("state", state);
    formData.append("city", city);
    formData.append("land_mark", landmark);
    const amenitiesArrayOfObjects = amenities.map((id) => ({ id: String(id) }));
    formData.append("aminities", JSON.stringify(amenitiesArrayOfObjects));
    formData.append("total_township_area", projectSize);
    formData.append("key_transport", JSON.stringify(keyTransports));
    formData.append("status", status);
    formData.append("location_map", locationMap);

    if (image1) formData.append("thumbnail", image1);
    if (imageprojectmap) formData.append("map_pdf", imageprojectmap);

    formData.append("project_status", projectStatus);

    propertyChainPapers.forEach((file) => {
      formData.append("property_chain_papers[]", file);
    });

    images.forEach((imageFile) => {
      formData.append("image[]", imageFile);
    });

    const authToken = localStorage.getItem("token");

    if (!authToken) {
      showCustomModal(
        "Authentication token not found. Please log in.",
        "error"
      );
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetch(`${API_URL}/project-create`, {
        method: "POST",
        headers: { Authorization: `Bearer ${authToken}` },
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Server error response:", errorText);
        throw new Error(`Server responded with status ${response.status}`);
      }

      const result = await response.json();
      if (result.success == "1" || result.status == "1") {
        showCustomModal(
          result.message || "Project has been created successfully!",
          "success"
        );
        // Reset all fields
        setName("");
        setProjectSize("");
        setStatus("active");
        setProjectStatus("ongoing");
        setImages([]);
        setImage1(null);
        setimageprojectmap(null);
        setReraRegistrationNo("");
        setLocation("");
        setDescription("");
        setLegality("");
        setYoutubeLink("");
        setBusinessVolume("");
        setCity("");
        setState("");
        setLandmark("");
        setAmenities([]);
        setPropertyChainPapers([]);
        setSelectedStateId("");
        setKeyTransports([]);
        setNewTransportName("");
        setNewTransportDistance("");
        setLocationMap("");

        if (imageInputRef.current) imageInputRef.current.value = "";
        if (imageInputRef1.current) imageInputRef1.current.value = "";
        if (imageInputRef2.current) imageInputRef2.current.value = "";
        if (propertyChainPaperRef.current)
          propertyChainPaperRef.current.value = "";

        setTimeout(() => navigate("/all-project"), 3000);
      } else {
        const errorMessage = result.message || "Failed to create project.";
        showCustomModal(`Error: ${errorMessage}`, "error");
      }
    } catch (error) {
      console.error("Error creating project:", error);
      showCustomModal(
        `An unexpected error occurred: ${error.message || ""}`,
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  // ═══════════════════════════════════════════
  // 🎨 RENDER
  // ═══════════════════════════════════════════
  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          {/* ═══════ HEADER CARD ═══════ */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "20px",
              boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
              border: "1.5px solid #e2e8f0",
              padding: "24px 30px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
              flexWrap: "wrap",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "5px",
                background:
                  "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "16px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "26px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                flexShrink: 0,
              }}
            >
              🏗️
            </div>
            <div style={{ flex: 1, minWidth: "200px" }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                Create New Project
              </h1>
              <p
                style={{
                  margin: "3px 0 0",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                Fill in the details below to add a new project
              </p>
            </div>

            <button
              type="button"
              onClick={() => navigate("/all-project")}
              style={{
                padding: "10px 20px",
                borderRadius: "10px",
                border: "1.5px solid #e2e8f0",
                background: "#ffffff",
                color: "#1e5799",
                fontSize: "13px",
                fontWeight: "700",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                transition: "all 0.2s ease",
                boxShadow: "0 2px 8px rgba(30, 87, 153, 0.06)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#f0f6ff";
                e.currentTarget.style.borderColor = "#1e5799";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "#ffffff";
                e.currentTarget.style.borderColor = "#e2e8f0";
              }}
            >
              <FaArrowLeft size={12} /> Back
            </button>
          </div>

          {/* ═══════ MAIN CARD ═══════ */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "20px",
              boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
              border: "1.5px solid #e2e8f0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "5px",
                background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div style={{ padding: "40px 40px 30px" }}>
              <Form onSubmit={handleSubmit}>
                {/* ═══════ SECTION: BASIC INFO ═══════ */}
                <div style={{ ...sectionHeaderStyle, marginTop: 0 }}>
                  <div style={sectionIconStyle}>
                    <FaBuilding />
                  </div>
                  <h6 style={sectionTitleStyle}>Basic Information</h6>
                </div>

                {/* Row 1 — 3 fields */}
                <Row className="g-4">
                  <Col md={4}>
                    <Form.Group style={fieldGroupStyle}>
                      <Form.Label style={labelStyle}>
                        Project Name <span style={{ color: "#dc2626" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value);
                          if (errors.name)
                            setErrors((prev) => ({ ...prev, name: null }));
                        }}
                        placeholder="e.g., Grand Residency"
                        isInvalid={!!errors.name}
                        style={inputStyle}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.name}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group style={fieldGroupStyle}>
                      <Form.Label style={labelStyle}>
                        Total Townships (Sq. Yard){" "}
                        <span style={{ color: "#dc2626" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        value={projectSize}
                        onChange={(e) => {
                          setProjectSize(e.target.value);
                          if (errors.projectSize)
                            setErrors((prev) => ({
                              ...prev,
                              projectSize: null,
                            }));
                        }}
                        placeholder="e.g., 10000"
                        step="1"
                        min="0"
                        isInvalid={!!errors.projectSize}
                        style={inputStyle}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.projectSize}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group style={fieldGroupStyle}>
                      <Form.Label style={labelStyle}>
                        Project RERA Number{" "}
                        <span style={{ color: "#dc2626" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={reraRegistrationNo}
                        onChange={(e) => {
                          setReraRegistrationNo(e.target.value);
                          if (errors.reraRegistrationNo)
                            setErrors((prev) => ({
                              ...prev,
                              reraRegistrationNo: null,
                            }));
                        }}
                        placeholder="Enter RERA registration number"
                        isInvalid={!!errors.reraRegistrationNo}
                        style={inputStyle}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.reraRegistrationNo}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                {/* Row 2 — 3 fields */}
                <Row className="g-4">
                  <Col md={4}>
                    <Form.Group style={fieldGroupStyle}>
                      <Form.Label style={labelStyle}>
                        Location <span style={{ color: "#dc2626" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={location}
                        onChange={(e) => {
                          setLocation(e.target.value);
                          if (errors.location)
                            setErrors((prev) => ({
                              ...prev,
                              location: null,
                            }));
                        }}
                        placeholder="Enter project location"
                        isInvalid={!!errors.location}
                        style={inputStyle}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.location}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group style={fieldGroupStyle}>
                      <Form.Label style={labelStyle}>
                        Location Map Link{" "}
                        <span style={{ color: "#dc2626" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="url"
                        value={locationMap}
                        onChange={(e) => {
                          setLocationMap(e.target.value);
                          if (errors.locationMap)
                            setErrors((prev) => ({
                              ...prev,
                              locationMap: null,
                            }));
                        }}
                        placeholder="Enter Google Maps link"
                        isInvalid={!!errors.locationMap}
                        style={inputStyle}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.locationMap}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group style={fieldGroupStyle}>
                      <Form.Label style={labelStyle}>
                        Business Volume(%){" "}
                        <span style={{ color: "#94a3b8" }}>(Optional)</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        value={businessVolume}
                        onChange={(e) => {
                          setBusinessVolume(e.target.value);
                          if (errors.businessVolume)
                            setErrors((prev) => ({
                              ...prev,
                              businessVolume: null,
                            }));
                        }}
                        placeholder="Enter business volume"
                        isInvalid={!!errors.businessVolume}
                        style={inputStyle}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.businessVolume}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                {/* ═══════ SECTION: LOCATION DETAILS ═══════ */}
                <div style={sectionHeaderStyle}>
                  <div style={sectionIconStyle}>
                    <FaMapMarkerAlt />
                  </div>
                  <h6 style={sectionTitleStyle}>Location Details</h6>
                </div>

                {/* Row — 3 fields */}
                <Row className="g-4">
                  <Col md={4}>
                    <Form.Group style={fieldGroupStyle}>
                      <Form.Label style={labelStyle}>
                        State <span style={{ color: "#dc2626" }}>*</span>
                      </Form.Label>
                      <Form.Select
                        value={state}
                        onChange={(e) => {
                          setState(e.target.value);
                          setSelectedStateId(e.target.value);
                          setCity("");
                          if (errors.state)
                            setErrors((prev) => ({ ...prev, state: null }));
                          if (errors.city)
                            setErrors((prev) => ({ ...prev, city: null }));
                        }}
                        isInvalid={!!errors.state}
                        style={inputStyle}
                      >
                        <option value="">Select State</option>
                        {statesList.map((s) => (
                          <option key={s.id} value={s.id}>
                            {s.name}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.state}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group style={fieldGroupStyle}>
                      <Form.Label style={labelStyle}>
                        City <span style={{ color: "#dc2626" }}>*</span>
                      </Form.Label>
                      <Form.Select
                        value={city}
                        onChange={(e) => {
                          setCity(e.target.value);
                          if (errors.city)
                            setErrors((prev) => ({ ...prev, city: null }));
                        }}
                        isInvalid={!!errors.city}
                        disabled={!selectedStateId || citiesList.length === 0}
                        style={{
                          ...inputStyle,
                          background:
                            !selectedStateId || citiesList.length === 0
                              ? "#f8fafc"
                              : "#ffffff",
                          cursor:
                            !selectedStateId || citiesList.length === 0
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        <option value="">Select City</option>
                        {citiesList.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.name}
                          </option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.city}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group style={fieldGroupStyle}>
                      <Form.Label style={labelStyle}>
                        Landmark <span style={{ color: "#dc2626" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={landmark}
                        onChange={(e) => {
                          setLandmark(e.target.value);
                          if (errors.landmark)
                            setErrors((prev) => ({
                              ...prev,
                              landmark: null,
                            }));
                        }}
                        placeholder="Enter nearest landmark"
                        isInvalid={!!errors.landmark}
                        style={inputStyle}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.landmark}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                {/* ═══════ SECTION: AMENITIES & TRANSPORT ═══════ */}
                <div style={sectionHeaderStyle}>
                  <div style={sectionIconStyle}>
                    <FaCheckCircle />
                  </div>
                  <h6 style={sectionTitleStyle}>Amenities & Transport</h6>
                </div>

                <Row className="g-4">
                  <Col md={4}>
                    <Form.Group style={fieldGroupStyle}>
                      <Form.Label style={labelStyle}>
                        Amenities <span style={{ color: "#dc2626" }}>*</span>
                      </Form.Label>
                      <Dropdown className={errors?.amenities ? "is-invalid" : ""}>
                        <Dropdown.Toggle
                          variant="transparent"
                          id="dropdown-amenities"
                          className="w-100 text-start"
                          style={{
                            ...inputStyle,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            borderColor: errors?.amenities ? "#dc2626" : "#e2e8f0",
                          }}
                        >
                          {amenities.length > 0
                            ? `${amenities.length} selected`
                            : "Select Amenities"}
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          style={{
                            maxHeight: "200px",
                            overflowY: "auto",
                            width: "100%",
                            borderRadius: "12px",
                            boxShadow: "0 12px 40px rgba(30, 87, 153, 0.15)",
                            border: "1.5px solid #e2e8f0",
                          }}
                        >
                          {availableAmenities.map((amenity) => (
                            <Form.Check
                              key={amenity.id}
                              type="checkbox"
                              id={`amenity-${amenity.id}`}
                              label={amenity.name}
                              checked={amenities.includes(amenity.id)}
                              onChange={() => handleAmenityToggle(amenity.id)}
                              className="mx-3 my-1 d-flex gap-2 align-items-center"
                              style={{
                                fontSize: "13px",
                                fontWeight: "500",
                                color: "#1e3a5f",
                              }}
                            />
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                      {errors.amenities && (
                        <div
                          style={{
                            color: "#dc2626",
                            fontSize: "12px",
                            marginTop: "6px",
                            fontWeight: "600",
                          }}
                        >
                          {errors.amenities}
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group style={fieldGroupStyle}>
                      <Form.Label style={labelStyle}>
                        Property Chain Papers (PDF)
                      </Form.Label>
                      <Form.Control
                        type="file"
                        accept="application/pdf"
                        multiple
                        onChange={handlePropertyChainPaperChange}
                        isInvalid={!!errors.propertyChainPapers}
                        ref={propertyChainPaperRef}
                        style={inputStyle}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.propertyChainPapers}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group style={fieldGroupStyle}>
                      <Form.Label style={labelStyle}>
                        Key Transport <span style={{ color: "#dc2626" }}>*</span>
                      </Form.Label>
                      <div style={{ display: "flex", gap: "8px" }}>
                        <Form.Control
                          type="text"
                          placeholder="e.g., Malls"
                          value={newTransportName}
                          onChange={(e) => setNewTransportName(e.target.value)}
                          isInvalid={
                            !!errors.keyTransports && keyTransports.length === 0
                          }
                          style={{ ...inputStyle, flex: 1 }}
                        />
                        <Form.Control
                          type="text"
                          placeholder="e.g., 2KM"
                          value={newTransportDistance}
                          onChange={(e) => setNewTransportDistance(e.target.value)}
                          isInvalid={
                            !!errors.keyTransports && keyTransports.length === 0
                          }
                          style={{ ...inputStyle, flex: 1 }}
                        />
                        <button
                          type="button"
                          onClick={addKeyTransport}
                          style={{
                            padding: "12px 16px",
                            borderRadius: "10px",
                            border: "none",
                            background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                            color: "#ffffff",
                            fontSize: "13px",
                            fontWeight: "700",
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "6px",
                            boxShadow: "0 4px 12px rgba(30, 87, 153, 0.3)",
                            flexShrink: 0,
                          }}
                        >
                          <FaPlus size={11} />
                        </button>
                      </div>
                      {errors.keyTransports && (
                        <div
                          style={{
                            color: "#dc2626",
                            fontSize: "12px",
                            marginTop: "6px",
                            fontWeight: "600",
                          }}
                        >
                          {errors.keyTransports}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                {/* Key Transport List — full width */}
                {keyTransports.length > 0 && (
                  <div
                    style={{
                      marginTop: "14px",
                      border: "1.5px solid #e2e8f0",
                      borderRadius: "12px",
                      padding: "16px",
                      background: "#f8fafc",
                    }}
                  >
                    <h6
                      style={{
                        margin: "0 0 12px",
                        fontSize: "12px",
                        fontWeight: "800",
                        color: "#1e5799",
                        textTransform: "uppercase",
                        letterSpacing: "0.3px",
                      }}
                    >
                      Added Locations:
                    </h6>
                    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                      {keyTransports.map((item, index) => (
                        <li
                          key={index}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "10px 14px",
                            borderRadius: "8px",
                            background: "#ffffff",
                            border: "1.5px solid #e2e8f0",
                            marginBottom: "8px",
                          }}
                        >
                          <span style={{ fontSize: "13px", color: "#1e3a5f" }}>
                            <strong style={{ color: "#1e5799" }}>{item.name}:</strong>{" "}
                            {item.distance}
                          </span>
                          <button
                            type="button"
                            onClick={() => removeKeyTransport(index)}
                            style={{
                              padding: "5px 12px",
                              borderRadius: "8px",
                              border: "1.5px solid #fca5a5",
                              background: "#feeaeb",
                              color: "#dc2626",
                              fontSize: "11.5px",
                              fontWeight: "700",
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <FaTrash size={10} /> Remove
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* ═══════ SECTION: MEDIA & DESCRIPTION ═══════ */}
                <div style={sectionHeaderStyle}>
                  <div style={sectionIconStyle}>
                    <FaImage />
                  </div>
                  <h6 style={sectionTitleStyle}>Media & Description</h6>
                </div>

                <Row className="g-4">
                  <Col md={4}>
                    <Form.Group style={fieldGroupStyle}>
                      <Form.Label style={labelStyle}>
                        Status <span style={{ color: "#dc2626" }}>*</span>
                      </Form.Label>
                      <Form.Select
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        style={inputStyle}
                      >
                        <option value="active">Show</option>
                        <option value="inactive">Hide</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group style={fieldGroupStyle}>
                      <Form.Label style={labelStyle}>
                        Project Status <span style={{ color: "#dc2626" }}>*</span>
                      </Form.Label>
                      <Form.Select
                        value={projectStatus}
                        onChange={(e) => {
                          setProjectStatus(e.target.value);
                          if (errors.projectStatus)
                            setErrors((prev) => ({
                              ...prev,
                              projectStatus: null,
                            }));
                        }}
                        isInvalid={!!errors.projectStatus}
                        style={inputStyle}
                      >
                        <option value="ongoing">Ongoing Project</option>
                        <option value="complete">Complete Project</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {errors.projectStatus}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group style={fieldGroupStyle}>
                      <Form.Label style={labelStyle}>
                        Youtube Link
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={youtubeLink}
                        onChange={(e) => {
                          setYoutubeLink(e.target.value);
                          if (errors.youtubeLink)
                            setErrors((prev) => ({
                              ...prev,
                              youtubeLink: null,
                            }));
                        }}
                        placeholder="Enter Your Youtube Link"
                        isInvalid={!!errors.youtubeLink}
                        style={inputStyle}
                      />
                      {errors.youtubeLink && (
                        <div
                          style={{
                            color: "#dc2626",
                            fontSize: "12px",
                            marginTop: "6px",
                            fontWeight: "600",
                          }}
                        >
                          {errors.youtubeLink}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                {/* Full-width textareas */}
                <Form.Group style={fieldGroupStyle}>
                  <Form.Label style={labelStyle}>
                    Description <span style={{ color: "#dc2626" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    value={description}
                    onChange={(e) => {
                      setDescription(e.target.value);
                      if (errors.description)
                        setErrors((prev) => ({
                          ...prev,
                          description: null,
                        }));
                    }}
                    placeholder="Enter Description"
                    isInvalid={!!errors.description}
                    style={{ ...inputStyle, resize: "vertical" }}
                  />
                  {errors.description && (
                    <div
                      style={{
                        color: "#dc2626",
                        fontSize: "12px",
                        marginTop: "6px",
                        fontWeight: "600",
                      }}
                    >
                      {errors.description}
                    </div>
                  )}
                </Form.Group>

                <Form.Group style={fieldGroupStyle}>
                  <Form.Label style={labelStyle}>
                    Approved Authority <span style={{ color: "#dc2626" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    value={legality}
                    onChange={(e) => {
                      setLegality(e.target.value);
                      if (errors.legality)
                        setErrors((prev) => ({ ...prev, legality: null }));
                    }}
                    placeholder="Enter legality details"
                    isInvalid={!!errors.legality}
                    style={{ ...inputStyle, resize: "vertical" }}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.legality}
                  </Form.Control.Feedback>
                </Form.Group>

                <Form.Group style={fieldGroupStyle}>
                  <Form.Label style={labelStyle}>
                    Project Images (Multiple)
                  </Form.Label>
                  <Form.Control
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleImageChange}
                    isInvalid={!!errors.images}
                    ref={imageInputRef}
                    style={inputStyle}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.images}
                  </Form.Control.Feedback>
                  {images.length > 0 && (
                    <div
                      style={{
                        marginTop: "12px",
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                      }}
                    >
                      {images.map((file, index) => (
                        <div
                          key={index}
                          style={{
                            position: "relative",
                            width: "100px",
                            height: "100px",
                          }}
                        >
                          <img
                            src={URL.createObjectURL(file)}
                            alt={`Preview ${index}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "10px",
                              border: "1.5px solid #e2e8f0",
                            }}
                          />
                          <button
                            type="button"
                            onClick={() => removeImage(index)}
                            style={{
                              position: "absolute",
                              top: "-6px",
                              right: "-6px",
                              width: "22px",
                              height: "22px",
                              borderRadius: "50%",
                              border: "none",
                              background: "#dc2626",
                              color: "#ffffff",
                              fontSize: "12px",
                              fontWeight: "700",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                            }}
                          >
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </Form.Group>

                <Row className="g-4">
                  <Col md={6}>
                    <Form.Group style={fieldGroupStyle}>
                      <Form.Label style={labelStyle}>
                        Thumbnail Image
                      </Form.Label>
                      <Form.Control
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange1}
                        isInvalid={!!errors.image1}
                        ref={imageInputRef1}
                        style={inputStyle}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.image1}
                      </Form.Control.Feedback>
                      {image1 && (
                        <div
                          style={{
                            marginTop: "12px",
                            position: "relative",
                            display: "inline-block",
                            width: "100px",
                            height: "100px",
                          }}
                        >
                          <img
                            src={URL.createObjectURL(image1)}
                            alt="Thumbnail Preview"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "10px",
                              border: "1.5px solid #22c55e",
                            }}
                          />
                          <button
                            type="button"
                            onClick={removeImage1}
                            style={{
                              position: "absolute",
                              top: "-6px",
                              right: "-6px",
                              width: "22px",
                              height: "22px",
                              borderRadius: "50%",
                              border: "none",
                              background: "#dc2626",
                              color: "#ffffff",
                              fontSize: "12px",
                              fontWeight: "700",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                            }}
                          >
                            ×
                          </button>
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group style={fieldGroupStyle}>
                      <Form.Label style={labelStyle}>
                        Project Map (PDF)
                      </Form.Label>
                      <Form.Control
                        type="file"
                        accept="application/pdf"
                        onChange={handleImageChange2}
                        isInvalid={!!errors.imageprojectmap}
                        ref={imageInputRef2}
                        style={inputStyle}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.imageprojectmap}
                      </Form.Control.Feedback>
                      {imageprojectmap && (
                        <div
                          style={{
                            marginTop: "12px",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                            padding: "10px 14px",
                            borderRadius: "10px",
                            background: "linear-gradient(135deg, #feeaeb, #fecaca)",
                            border: "1.5px solid #fca5a5",
                          }}
                        >
                          <FaFilePdf size={14} style={{ color: "#dc2626" }} />
                          <span
                            style={{
                              fontSize: "12px",
                              color: "#991b1b",
                              fontWeight: "600",
                              maxWidth: "160px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            title={imageprojectmap.name}
                          >
                            {imageprojectmap.name}
                          </span>
                          <button
                            type="button"
                            onClick={removeImage2}
                            style={{
                              width: "20px",
                              height: "20px",
                              borderRadius: "50%",
                              border: "none",
                              background: "#dc2626",
                              color: "#ffffff",
                              fontSize: "10px",
                              fontWeight: "700",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                            }}
                          >
                            ×
                          </button>
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                {/* ═══════ SUBMIT BUTTON ═══════ */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    paddingTop: "32px",
                    borderTop: "1.5px dashed #e2e8f0",
                    marginTop: "24px",
                  }}
                >
                  <button
                    type="submit"
                    disabled={isLoading}
                    style={{
                      padding: "14px 46px",
                      borderRadius: "12px",
                      border: "none",
                      background: isLoading
                        ? "#cbd5e1"
                        : "linear-gradient(135deg, #1e5799, #2b6cb0)",
                      color: "#ffffff",
                      fontSize: "14.5px",
                      fontWeight: "800",
                      letterSpacing: "0.5px",
                      cursor: isLoading ? "not-allowed" : "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: isLoading
                        ? "none"
                        : "0 8px 24px rgba(30, 87, 153, 0.35)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                      minWidth: "230px",
                    }}
                    onMouseEnter={(e) => {
                      if (!isLoading) {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow =
                          "0 12px 32px rgba(30, 87, 153, 0.45)";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isLoading) {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 8px 24px rgba(30, 87, 153, 0.35)";
                      }
                    }}
                  >
                    {isLoading ? (
                      <>
                        <span
                          style={{
                            width: "16px",
                            height: "16px",
                            border: "2px solid rgba(255,255,255,0.3)",
                            borderTop: "2px solid #ffffff",
                            borderRadius: "50%",
                            display: "inline-block",
                            animation: "spin 0.8s linear infinite",
                          }}
                        />
                        Creating...
                      </>
                    ) : (
                      <>
                        <FaSave size={14} /> Create Project
                      </>
                    )}
                  </button>
                </div>
              </Form>
            </div>
          </div>

          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "24px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>

      {/* ═══════ MESSAGE MODAL ═══════ */}
      {showModal && (
        <div
          onClick={closeCustomModal}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(15, 23, 42, 0.55)",
            backdropFilter: "blur(4px)",
            zIndex: 99999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#ffffff",
              borderRadius: "16px",
              overflow: "hidden",
              border: "none",
              boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
              maxWidth: "460px",
              width: "100%",
            }}
          >
            <div
              style={{
                height: "5px",
                background: "linear-gradient(135deg, #2b6cb0, #1e5799)",
              }}
            />

            <div
              style={{
                padding: "22px 22px 14px",
                display: "flex",
                alignItems: "center",
                gap: "14px",
              }}
            >
              <div
                style={{
                  width: "46px",
                  height: "46px",
                  borderRadius: "12px",
                  background: "linear-gradient(135deg, #e8f1fb, #dbeafe)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                  flexShrink: 0,
                  color: "#1e5799",
                }}
              >
                {modalType === "success" ? <FaCheckCircle /> : <FaTimesCircle />}
              </div>

              <div style={{ flex: 1 }}>
                <h5
                  style={{
                    margin: 0,
                    fontSize: "17px",
                    fontWeight: "800",
                    color: "#1e5799",
                    letterSpacing: "-0.2px",
                  }}
                >
                  {modalType === "success" ? "Success!" : "Error!"}
                </h5>
              </div>

              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  closeCustomModal();
                }}
                style={{
                  width: "34px",
                  height: "34px",
                  borderRadius: "8px",
                  border: "1.5px solid #e2e8f0",
                  background: "#ffffff",
                  color: "#64748b",
                  fontSize: "16px",
                  fontWeight: "700",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  transition: "all 0.2s ease",
                  padding: 0,
                  lineHeight: 1,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#f0f6ff";
                  e.currentTarget.style.color = "#1e5799";
                  e.currentTarget.style.borderColor = "#1e5799";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#ffffff";
                  e.currentTarget.style.color = "#64748b";
                  e.currentTarget.style.borderColor = "#e2e8f0";
                }}
              >
                ✕
              </button>
            </div>

            <div
              style={{
                padding: "0 22px 22px 82px",
                fontSize: "13.5px",
                color: "#475569",
                fontWeight: "500",
                lineHeight: "1.6",
              }}
            >
              {modalMessage}
            </div>

            <div
              style={{
                padding: "16px 22px",
                background: "#f8fafc",
                borderTop: "1px solid #e2e8f0",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  closeCustomModal();
                }}
                style={{
                  padding: "11px 48px",
                  borderRadius: "10px",
                  border: "none",
                  background: "linear-gradient(135deg, #2b6cb0, #1e5799)",
                  color: "#ffffff",
                  fontSize: "14px",
                  fontWeight: "800",
                  cursor: "pointer",
                  letterSpacing: "0.3px",
                  boxShadow: "0 6px 18px rgba(30, 87, 153, 0.35)",
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-1px)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 24px rgba(30, 87, 153, 0.45)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 6px 18px rgba(30, 87, 153, 0.35)";
                }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
}

export default CreateProject;